document.documentElement.className = document.documentElement.className.replace('no-js', 'js');
      if (Shopify.designMode) {
        document.documentElement.classList.add('shopify-design-mode');
      }

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="AccessibleNav"] .sub-menu-block').forEach((subMenu) => {
  subMenu.setAttribute('role', 'menu');
});

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );

    this.input.addEventListener('input', this.onInputChange.bind(this));
    
    // Store timeout reference
    this.errorTimeout = null;
  }

  onButtonClick(event) {
    event.preventDefault();

    const previousValue = parseInt(this.input.value, 10) || 1;
    const maxQuantity = parseInt(this.input.getAttribute('max')) || 9999;
    const minQuantity = parseInt(this.input.getAttribute('min')) || 1;
     
    let newValue = previousValue;
    
    // Check before incrementing/decrementing
    if (event.target.name === 'plus') {
      if (previousValue >= maxQuantity) {
        // Show error without changing value
        this.showErrorMessage(`You can only add ${maxQuantity} of this item to your cart.`);
        return;
      }
      newValue = previousValue + 1;
    } else if (event.target.name === 'minus') {
      if (previousValue <= minQuantity) {
        // Don't show error for min, just return
        return;
      }
      newValue = previousValue - 1;
    }
    
    // Update value
    this.input.value = newValue;
    
    // Validate and show error if needed
    this.validateQuantity();
    
    // Dispatch change event
    if (previousValue !== newValue) {
      this.input.dispatchEvent(this.changeEvent);
    }
    
    // Update subtotal
    this.updateSubtotal(event);
  }

  onInputChange(event) {
    this.validateQuantity();
    this.updateSubtotal(event);
  }

  showErrorMessage(message) {
    const quantityInputElement = this;
    let errorElement = null;
    
    // Check if we're on mobile
    const isMobile = window.innerWidth <= 768;
    const isCartDrawer = quantityInputElement.closest('.cart-item, .cart-row, [data-cart-item]') !== null;
    
    // Find or create error element
    errorElement = quantityInputElement.parentElement?.querySelector('.quantity-error');
    
    if (!errorElement) {
      errorElement = document.createElement('div');
      errorElement.className = 'quantity-error';
      
      if (isMobile || !isCartDrawer) {
        quantityInputElement.insertAdjacentElement('afterend', errorElement);
      } else {
        quantityInputElement.insertAdjacentElement('afterend', errorElement);
      }
    }
    
    // Clear any existing timeout
    if (this.errorTimeout) {
      clearTimeout(this.errorTimeout);
    }
    
    // Show error message
    errorElement.textContent = message;
    errorElement.style.display = 'block';
    errorElement.style.opacity = '1';
    errorElement.setAttribute('role', 'alert');
    
    // Add error class to input
    if (this.input) {
      this.input.classList.add('quantity-input-error');
    }
    
    // Auto-hide after 5 seconds
    this.errorTimeout = setTimeout(() => {
      if (errorElement) {
        errorElement.style.opacity = '0';
        setTimeout(() => {
          if (errorElement) {
            errorElement.style.display = 'none';
            errorElement.textContent = '';
          }
          if (this.input) {
            this.input.classList.remove('quantity-input-error');
            this.input.style.borderColor = '';
          }
        }, 300);
      }
      this.errorTimeout = null;
    }, 5000);
  }

  validateQuantity() {
    let value = parseInt(this.input.value) || 1;

    const maxQuantity = parseInt(this.input.getAttribute('max')) || 9999;
    const minQuantity = parseInt(this.input.getAttribute('min')) || 1;

    const quantityInputElement = this;
    let errorElement = null;

    // Check if we're on mobile
    const isMobile = window.innerWidth <= 768;
    const isCartDrawer = quantityInputElement.closest('.cart-item, .cart-row, [data-cart-item]') !== null;
    
    errorElement = quantityInputElement.parentElement?.querySelector('.quantity-error');
    
    if (!errorElement) {
      errorElement = document.createElement('div');
      errorElement.className = 'quantity-error';
      
      if (isMobile || !isCartDrawer) {
        quantityInputElement.insertAdjacentElement('afterend', errorElement);
      } else {
        quantityInputElement.insertAdjacentElement('afterend', errorElement);
      }
    }

    // Validation logic
    let hasError = false;
    let errorMessage = '';

    if (value > maxQuantity) {
      value = maxQuantity;
      hasError = true;
      errorMessage = `You can only add ${maxQuantity} of this item to your cart.`;
    } else if (value < minQuantity) {
      value = minQuantity;
      hasError = true;
      errorMessage = `Minimum ${minQuantity} required`;
    }

    // Update input value if corrected
    if (this.input.value != value) {
      this.input.value = value;
    }

    // Update error display
    if (hasError) {
      // Clear any existing timeout
      if (this.errorTimeout) {
        clearTimeout(this.errorTimeout);
      }
      
      errorElement.textContent = errorMessage;
      errorElement.style.display = 'block';
      errorElement.style.opacity = '1';
      errorElement.setAttribute('role', 'alert');
      
      // Add visual feedback to input
      if (this.input) {
        this.input.classList.add('quantity-input-error');
      }
      
      // Auto-hide after 5 seconds
      this.errorTimeout = setTimeout(() => {
        if (errorElement) {
          errorElement.style.opacity = '0';
          setTimeout(() => {
            if (errorElement) {
              errorElement.style.display = 'none';
              errorElement.textContent = '';
            }
            if (this.input) {
              this.input.classList.remove('quantity-input-error');
              this.input.style.borderColor = '';
            }
          }, 300);
        }
        this.errorTimeout = null;
      }, 5000);
      
    } else {
      // Only hide error if no error and error element exists
      if (errorElement && errorElement.style.display !== 'none') {
        errorElement.style.display = 'none';
        errorElement.textContent = '';
        if (this.input) {
          this.input.classList.remove('quantity-input-error');
          this.input.style.borderColor = '';
        }
        if (this.errorTimeout) {
          clearTimeout(this.errorTimeout);
          this.errorTimeout = null;
        }
      }
    }
  }

  updateSubtotal(event) {
    const IncValue = parseInt(this.input.value) || 1;
    
    // Determine if we're on product page or cart drawer
    const isProductPage = document.querySelector('.product__info-container') !== null;
    const isCartDrawer = this.closest('.cart-drawer, .ajaxcart__inner, .cart-items') !== null;
    
    let subtotal = 0;
    let subtotalElement = null;
    
    if (isProductPage) {
      // Main product page logic
      const priceElement = document.querySelector('.product__info-container');
      const currentPrice = priceElement?.querySelector('.product-price-current');
      
      if (!currentPrice) return;
      
      const priceData = currentPrice.dataset.price;
      const EvalPrice = parseFloat(priceData);
      subtotal = IncValue * EvalPrice;
      
      subtotalElement = document.querySelector('#subtotal-value');
      
    } else if (isCartDrawer) {
      // Cart drawer logic
      const cartItem = this.closest('.cart-item, .cart-row, [data-cart-item]');
      if (!cartItem) return;
      
      // Get item price
      const priceElement = cartItem.querySelector('.cart-item__price, .product-price, [data-price]');
      if (!priceElement) return;
      
      let itemPrice = 0;
      if (priceElement.dataset.price) {
        itemPrice = parseFloat(priceElement.dataset.price);
      } else {
        // Extract price from text (removing currency symbols)
        const priceText = priceElement.innerText.replace(/[^0-9.-]/g, '');
        itemPrice = parseFloat(priceText);
      }
      
      subtotal = IncValue * itemPrice;
      
      // Find subtotal element in cart item
      subtotalElement = cartItem.querySelector('.cart-item__subtotal, .line-item-subtotal, [data-subtotal]');
      
      // If not found, create one
      if (!subtotalElement) {
        subtotalElement = document.createElement('span');
        subtotalElement.className = 'cart-item__subtotal';
        const priceWrapper = cartItem.querySelector('.cart-item__price-wrapper, .cart-item__details');
        if (priceWrapper) {
          priceWrapper.appendChild(subtotalElement);
        }
      }
    }
    
    if (!subtotalElement) {
      console.warn('Subtotal element not found');
      return;
    }
    
    // Update the subtotal display
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney && typeof DT_THEME !== 'undefined') {
      subtotalElement.innerText = Shopify.formatMoney(subtotal, DT_THEME.moneyFormat);
    } else {
      // Fallback formatting
      const currencySymbol = DT_THEME?.currencySymbol || '$';
      subtotalElement.innerText = `${currencySymbol}${subtotal.toFixed(2)}`;
    }
    
    // Trigger custom event for any other components that need to know about subtotal update
    const subtotalEvent = new CustomEvent('cart:subtotal-updated', {
      detail: {
        subtotal: subtotal,
        quantity: IncValue,
        context: isProductPage ? 'product-page' : 'cart-drawer'
      }
    });
    document.dispatchEvent(subtotalEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];

    if (
      value == option.value ||
      value == option.textContent
    ) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
  var opt = this.countryEl.options[this.countryEl.selectedIndex];
  var raw = opt.getAttribute('data-provinces');
  var provinces = JSON.parse(raw);

  this.clearOptions(this.provinceEl);

  if (provinces && provinces.length == 0) {
    this.provinceContainer.style.display = 'none';
  } else {
    for (var i = 0; i < provinces.length; i++) {
      var opt = document.createElement('option');

      opt.value = provinces[i][0];
      opt.textContent = provinces[i][1];

      this.provinceEl.appendChild(opt);
    }

    this.provinceContainer.style.display = "";
  }
},

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
  for (var i = 0, count = values.length; i < values.length; i++) {
    var opt = document.createElement('option');

    opt.value = values[i];
    opt.textContent = values[i];

    selector.appendChild(opt);
  }
}
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );

  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;
    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    var topBarHeight = document.getElementById('shopify-section-top-bar').offsetHeight;
     var announcementBarHeight = document.getElementById('shopify-section-announcement-bar').offsetHeight;
    var drawerTopHeight= topBarHeight + announcementBarHeight;
    document.getElementById("menu-drawer").style.top = '-'+drawerTopHeight+ "px";
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);


class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    if (!button) return;

    button.addEventListener('click', async () => {
      const selector = this.getAttribute('data-modal');
      await customElements.whenDefined('quick-add-modal');

      const modal = document.querySelector(selector);

      console.log('After upgrade:', modal);
      console.log('Has show():', typeof modal?.show);

      if (modal && typeof modal.show === 'function') {
        modal.show(button);
      } else {
        console.error('Still not upgraded:', modal);
      }
    });
  }
}

customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.initialized) return;

    this.initialized = true;

    this.addEventListener('click', (event) => {
      const poster = event.target.closest('[id^="Deferred-Poster-"]');
      // alert('clicked');
      this.loadContent();
    });
  }

  loadContent(focus = true) {

    if (typeof window.pauseAllMedia === 'function') {
      window.pauseAllMedia();
    }

    if (this.getAttribute('loaded')) return;

    const template = this.querySelector('template');

    if (!template) return;

    const clone = template.content.firstElementChild.cloneNode(true);


    this.setAttribute('loaded', true);

    const deferredElement = this.appendChild(clone);

    const poster = this.querySelector('.deferred-media__poster');

    if (poster) {
      poster.remove();
    }

    if (focus && deferredElement) {
      deferredElement.focus();
    }

    if (
      deferredElement &&
      deferredElement.nodeName === 'VIDEO' &&
      deferredElement.autoplay
    ) {
      deferredElement.play();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class EnhancedSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul[class*="thumbnail-list"], ul[class*="product__media-list"]');
    this.sliderItems = this.querySelectorAll('li[id^="Slide-"]');
    this.prevButton = this.querySelector('.main-prev-btn, .thumbnail-prev-btn');
    this.nextButton = this.querySelector('.main-next-btn, .thumbnail-next-btn');
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.isThumbnail = this.classList.contains('GalleryThumbnails');
    this.isMainSlider = this.classList.contains('GalleryViewerMain');
    this.autoScrollInterval = null;
    this.scrollTimeout = null;
    
    if (!this.slider) return;
    
    this.init();
  }
  
  init() {
    this.initSliderStyles();
    this.calculateDimensions();
    this.addEventListeners();
    this.updateButtons();
    
    window.addEventListener('resize', () => {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        this.calculateDimensions();
        this.updateButtons();
      }, 150);
    });
    
    if (this.isThumbnail) {
      this.enableThumbnailScroll();
      this.syncWithMainSlider();
    }
    
    if (this.isMainSlider) {
      this.syncThumbnails();
    }
  }
  
  initSliderStyles() {
    this.slider.style.display = 'flex';
    this.slider.style.overflowX = 'auto';
    this.slider.style.overflowY = 'hidden';
    this.slider.style.scrollBehavior = 'smooth';
    this.slider.style.scrollbarWidth = 'none';
    
    this.sliderItems.forEach(item => {
      item.style.flex = '0 0 auto';
      if (this.isThumbnail) {
        item.style.width = '80px';
        item.style.marginRight = '0px';
        item.style.cursor = 'pointer';
      } else {
        item.style.width = '100%';
        item.style.flexShrink = '0';
      }
    });
  }
  
  calculateDimensions() {
    if (this.isThumbnail && this.sliderItems.length > 0) {
      const firstItem = this.sliderItems[0];
      const itemWidth = firstItem.offsetWidth;
      const gap = 10;
      this.scrollStep = itemWidth + gap;
      
      const containerWidth = this.slider.parentElement?.offsetWidth || this.slider.offsetWidth;
      this.itemsPerView = Math.floor(containerWidth / this.scrollStep);
      this.totalPages = Math.max(1, Math.ceil(this.sliderItems.length / this.itemsPerView));
      
      if (this.pageTotalElement) {
        this.pageTotalElement.textContent = this.totalPages;
      }
    } else if (this.isMainSlider && this.sliderItems.length > 0) {
      const firstItem = this.sliderItems[0];
      this.scrollStep = firstItem.offsetWidth;
      this.totalPages = this.sliderItems.length;
      
      if (this.pageTotalElement) {
        this.pageTotalElement.textContent = this.totalPages;
      }
    }
  }
  
  addEventListeners() {
    this.slider.addEventListener('scroll', () => {
      this.updateButtons();
      this.updateCounter();
      
      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout);
      }
      
      this.scrollTimeout = setTimeout(() => {
        this.onScrollEnd();
      }, 150);
    });
    
    if (this.prevButton) {
      this.prevButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.scrollPrev();
      });
    }
    
    if (this.nextButton) {
      this.nextButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.scrollNext();
      });
    }
    
    this.setupTouchEvents();
    this.setupKeyboardNavigation();
  }
  
  setupTouchEvents() {
    let startX = 0;
    let startScrollLeft = 0;
    let isDragging = false;
    
    this.slider.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startScrollLeft = this.slider.scrollLeft;
      isDragging = true;
      this.slider.style.scrollBehavior = 'auto';
    });
    
    this.slider.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      const deltaX = e.touches[0].clientX - startX;
      this.slider.scrollLeft = startScrollLeft - deltaX;
      e.preventDefault();
    });
    
    this.slider.addEventListener('touchend', () => {
      isDragging = false;
      this.slider.style.scrollBehavior = 'smooth';
    });
    
    // Mouse drag for desktop
    let isMouseDown = false;
    let mouseStartX = 0;
    let mouseStartScrollLeft = 0;
    
    this.slider.addEventListener('mousedown', (e) => {
      if (e.button !== 0) return;
      isMouseDown = true;
      mouseStartX = e.clientX;
      mouseStartScrollLeft = this.slider.scrollLeft;
      this.slider.style.cursor = 'grabbing';
      this.slider.style.scrollBehavior = 'auto';
      e.preventDefault();
    });
    
    window.addEventListener('mousemove', (e) => {
      if (!isMouseDown) return;
      const deltaX = e.clientX - mouseStartX;
      this.slider.scrollLeft = mouseStartScrollLeft - deltaX;
    });
    
    window.addEventListener('mouseup', () => {
      isMouseDown = false;
      this.slider.style.cursor = '';
      this.slider.style.scrollBehavior = 'smooth';
    });
  }
  
  setupKeyboardNavigation() {
    if (!this.isMainSlider) return;
    
    this.slider.setAttribute('tabindex', '0');
    this.slider.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        this.scrollPrev();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        this.scrollNext();
      }
    });
  }
  
  enableThumbnailScroll() {
    this.sliderItems.forEach((item, index) => {
      const button = item.querySelector('button');
      if (button) {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          this.setActiveThumbnail(item);
          this.scrollToMainSlide(index);
        });
      }
    });
  }
  
  setActiveThumbnail(activeItem) {
    this.sliderItems.forEach(item => {
      const btn = item.querySelector('button');
      if (btn) {
        btn.removeAttribute('aria-current');
      }
      item.classList.remove('active-thumbnail');
    });
    
    const activeBtn = activeItem.querySelector('button');
    if (activeBtn) {
      activeBtn.setAttribute('aria-current', 'true');
    }
    activeItem.classList.add('active-thumbnail');
    this.scrollThumbnailIntoView(activeItem);
  }
  
  scrollThumbnailIntoView(thumbnail) {
    const thumbnailRect = thumbnail.getBoundingClientRect();
    const containerRect = this.slider.getBoundingClientRect();
    
    if (thumbnailRect.left < containerRect.left) {
      this.slider.scrollBy({
        left: thumbnailRect.left - containerRect.left - 10,
        behavior: 'smooth'
      });
    } else if (thumbnailRect.right > containerRect.right) {
      this.slider.scrollBy({
        left: thumbnailRect.right - containerRect.right + 10,
        behavior: 'smooth'
      });
    }
  }
  
  scrollToMainSlide(index) {
    const mainSlider = document.querySelector('#GalleryViewer-' + this.getSectionId());
    if (mainSlider && mainSlider.sliderComponent) {
      mainSlider.sliderComponent.scrollToSlide(index);
    }
  }
  
  syncWithMainSlider() {
    const mainSlider = document.querySelector('#GalleryViewer-' + this.getSectionId());
    if (mainSlider && mainSlider.sliderComponent) {
      mainSlider.sliderComponent.slider.addEventListener('scroll', () => {
        const scrollPosition = mainSlider.sliderComponent.slider.scrollLeft;
        const activeIndex = Math.round(scrollPosition / mainSlider.sliderComponent.scrollStep);
        
        if (this.sliderItems[activeIndex]) {
          this.setActiveThumbnail(this.sliderItems[activeIndex]);
        }
      });
    }
  }
  
  syncThumbnails() {
    const thumbnailSlider = document.querySelector('#GalleryThumbnails-' + this.getSectionId());
    if (thumbnailSlider && thumbnailSlider.sliderComponent) {
      this.thumbnailComponent = thumbnailSlider.sliderComponent;
    }
  }
  
  scrollToSlide(index) {
    if (index >= 0 && index < this.sliderItems.length) {
      const scrollPosition = index * this.scrollStep;
      this.slider.scrollTo({
        left: scrollPosition,
        behavior: 'smooth'
      });
      this.updateCounter();
    }
  }
  
  scrollPrev() {
    const currentScroll = this.slider.scrollLeft;
    const newScroll = currentScroll - this.scrollStep;
    this.slider.scrollTo({
      left: Math.max(0, newScroll),
      behavior: 'smooth'
    });
  }
  
  scrollNext() {
    const currentScroll = this.slider.scrollLeft;
    const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
    const newScroll = currentScroll + this.scrollStep;
    this.slider.scrollTo({
      left: Math.min(maxScroll, newScroll),
      behavior: 'smooth'
    });
  }
  
  updateButtons() {
    if (!this.prevButton || !this.nextButton) return;
    
    const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
    const currentScroll = this.slider.scrollLeft;
    
    if (currentScroll <= 5) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }
    
    if (currentScroll >= maxScroll - 5) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }
  
  updateCounter() {
    if (!this.currentPageElement || !this.pageTotalElement) return;
    
    let currentPage = 1;
    if (this.isThumbnail) {
      const currentItem = Math.round(this.slider.scrollLeft / this.scrollStep);
      currentPage = Math.floor(currentItem / this.itemsPerView) + 1;
    } else {
      currentPage = Math.round(this.slider.scrollLeft / this.scrollStep) + 1;
    }
    
    this.currentPageElement.textContent = Math.min(currentPage, this.totalPages);
  }
  
  onScrollEnd() {
    this.dispatchEvent(new CustomEvent('scrollEnd', {
      detail: {
        scrollLeft: this.slider.scrollLeft,
        activeIndex: Math.round(this.slider.scrollLeft / this.scrollStep)
      }
    }));
  }
  
  getSectionId() {
    const id = this.id;
    const match = id.match(/-(\d+)$/);
    return match ? match[1] : '';
  }
  
  startAutoPlay(interval = 5000) {
    if (this.autoScrollInterval) {
      clearInterval(this.autoScrollInterval);
    }
    
    this.autoScrollInterval = setInterval(() => {
      if (this.isMainSlider && !this.isHovered) {
        const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
        const currentScroll = this.slider.scrollLeft;
        
        if (currentScroll >= maxScroll - 5) {
          this.slider.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          this.scrollNext();
        }
      }
    }, interval);
  }
  
  stopAutoPlay() {
    if (this.autoScrollInterval) {
      clearInterval(this.autoScrollInterval);
      this.autoScrollInterval = null;
    }
  }
}

// Register the custom element
if (!customElements.get('slider-component')) {
  customElements.define('slider-component', EnhancedSliderComponent);
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    const sliders = document.querySelectorAll('slider-component');
    sliders.forEach(slider => {
      if (!slider.sliderComponent) {
        slider.sliderComponent = slider;
      }
    });
    
    const thumbnailSlider = document.querySelector('.GalleryThumbnails');
    if (thumbnailSlider && thumbnailSlider.sliderComponent) {
      const activeSlide = thumbnailSlider.querySelector('[aria-current="true"]');
      if (activeSlide) {
        const parentItem = activeSlide.closest('.thumbnail-list__item');
        if (parentItem) {
          thumbnailSlider.sliderComponent.setActiveThumbnail(parentItem);
        }
      }
    }
  }, 100);
});


document.addEventListener('shopify:section:load', (event) => {
  const section = event.detail.section;
  if (section && section.querySelector('slider-component')) {
    const sliders = section.querySelectorAll('slider-component');
    sliders.forEach(slider => {
      if (!slider.sliderComponent) {
        slider.sliderComponent = slider;
      }
    });
  }
});

class SlideshowComponent extends EnhancedSliderComponent {
  constructor() {
    super();
    this.slider = this.querySelector('[data-slider-options]');
    this.init();
  }

  init() {
    const predefine = {
      effect: 'slide',
      direction: 'horizontal',
      autoplay: true,
      autoplaySpeed: 5,
      space: 0,
      center: true,
      options: {},
    };
    const slider_options = this.slider.getAttribute('data-slider-options');
    if (slider_options === null || slider_options === '') {
      return null;
    }
    const grouping = $.extend(true, predefine, JSON.parse(slider_options));

    const isNumberic = /^\d+$/;
    Object.keys(grouping).forEach((key) => {
      if (typeof grouping[key] === 'string' && isNumberic.test(grouping[key])) {
        grouping[key] = parseInt(grouping[key], 10);
      }
    });
    let autoplay = false;
    if (grouping.auto_play > 0) {
      autoplay = {
        delay: grouping.auto_play * 1000,
      };
    }
    let loop = false;
    if (grouping.loop === 'true' || grouping.loop === true) {
      loop = true;
    }
    const option = $.extend(true, {
      init: false,
      spaceBetween: 0,
      loop,
      autoplay,
      speed: 2000,
      navigation: {
        nextEl: this.slider.querySelector('.swiper-button-next'),
        prevEl: this.slider.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: this.slider.querySelector('.swiper-pagination'),
        clickable: true,
      },
      lazy: true,
      effect: grouping.effect,
    }, grouping.options);
    const container = this.slider.querySelector('[data-swiper-slider]');
    const initiate = new Swiper(container, option);
    initiate.on('init', () => {
    initiate.update();
    });
    initiate.init();
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updatePickupAvailability();
    this.updateVariantStatuses();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.toggleAddButton(
        !this.currentVariant.available,
        this.currentVariant.available ? window.variantStrings.addToCart : window.variantStrings.soldOut
      );
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
   // window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }


  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        console.log(input.getAttribute('value'));
        input.innerText = window.variantStrings.replace('[value]', input.getAttribute('value'));
      }
    });
  }
  updatePickupAvailability() {
  const pickUpAvailability = document.querySelector('pickup-availability');
  const notifyStatus = document.getElementById(`notify-block-${this.dataset.section}`);
    if (!pickUpAvailability) return;
    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
      if (notifyStatus) notifyStatus.classList.add('visibility-hidden');
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.replaceChildren();     
    }
  }


  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
  fetch(
    `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
      this.dataset.originalSection
        ? this.dataset.originalSection
        : this.dataset.section
    }`
  )
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(
        responseText,
        'text/html'
      );

      const sectionId = this.dataset.originalSection
        ? this.dataset.originalSection
        : this.dataset.section;

      const replaceContent = (destinationId, sourceId) => {
        const destination = document.getElementById(destinationId);
        const source = html.getElementById(sourceId);

        if (source && destination) {
          destination.replaceChildren(
            ...source.cloneNode(true).childNodes
          );
        }

        return { source, destination };
      };

      replaceContent(
        `price-${this.dataset.section}`,
        `price-${sectionId}`
      );
      const {
        source: skuSource,
        destination: skuDestination
      } = replaceContent(
        `Sku-${this.dataset.section}`,
        `Sku-${sectionId}`
      );

      const {
        source: inventorySource,
        destination: inventoryDestination
      } = replaceContent(
        `Inventory-${this.dataset.section}`,
        `Inventory-${sectionId}`
      );

      replaceContent(
        `dt-stock-message-${this.dataset.section}`,
        `dt-stock-message-${sectionId}`
      );

      replaceContent(
        `sticky-price-${this.dataset.section}`,
        `sticky-price-${sectionId}`
      );

      replaceContent(
        `subtotal-${this.dataset.section}`,
        `subtotal-${sectionId}`
      );

      const stickyPrice = document.getElementById(
        `sticky-price-${this.dataset.section}`
      );

      if (stickyPrice) {
        stickyPrice.classList.remove('visibility-hidden');
      }

      this.toggleAddButton(
        !this.currentVariant.available,
        window.variantStrings.soldOut
      );

      if (inventoryDestination && inventorySource) {
        inventoryDestination.classList.toggle(
          'visibility-hidden',
          inventorySource.innerText === ''
        );
      }
    });
}

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
     const stickButton = document.getElementById('sticky-bar-button');

    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');


    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;


    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

     if (!stickButton) return;
    if (disable) {
      stickButton.setAttribute('disabled', 'disabled');
    } else {
      stickButton.removeAttribute('disabled');
    }
    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const stickyPrice = document.getElementById(`sticky-price-${this.dataset.section}`);
    const notifyStatus = document.getElementById(`notify-block-${this.dataset.section}`);
   const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
  //  if (sku) sku.classList.add('visibility-hidden');
    if (notifyStatus) notifyStatus.classList.remove('visibility-hidden');
    if (!inventory) return;
    if (inventory) inventory.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach((input) => {
        if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
          input.classList.remove('disabled');
        } else {
          input.classList.add('disabled');
        }
      });
    }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      fieldset.querySelector('.append-options-values').lastChild.textContent = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);
class SwiperSlider extends HTMLElement {
    constructor() {
        super(),
        this.slider = this.querySelector("[data-slider-options]"),
        this.init();
    }
    init() {
        const e = this.slider.getAttribute("data-slider-options");
        if (null === e || "" === e) return null;
        const t = $.extend(!0, {
                effect: "slide",
                direction: "horizontal",
                autoplay: !0,
                autoplaySpeed: 5,
                space: 30,
                center: !0,
                options: {}
            }, JSON.parse(e)),
            i = /^\d+$/;
        Object.keys(t).forEach((e => {
            "string" == typeof t[e] && i.test(t[e]) && (t[e] = parseInt(t[e], 10))
        }));
        let s = !1;
        t.auto_play > 0 && (s = {
            delay: 1e3 * t.auto_play
        });
        let l = !1,
            r = !1;
        "true" === t.loop || !0 === t.loop ? l = !0 : 1 === t.loop ? (l = !0, r = !0) : (r = !1, l = !1);
        const o = $.extend(!0, {
                init: !1,
                spaceBetween: t.gap,
                loop: l,
                preventClicks: true,
                preventClicksPropagation: true,
                autoplay: s,
                centeredSlides: r,
                navigation: {
                    nextEl: this.slider.querySelector(".swiper-button-next"),
                    prevEl: this.slider.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: this.slider.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                lazy: !0,
                focusableElements: 'input, select, option, textarea, video, label',
                breakpoints: {
                    320: {
                        slidesPerView: t.mobile,
                       spaceBetween: (0.5 * t.gap ),
                        slidesPerColumn: 1
                    },
                    577: {
                        slidesPerView: t.tablet,
                        slidesPerColumn: 1
                    },
                   781: {
                        slidesPerView: t.laptop,
                        slidesPerColumn: 1
                    },
                    1200: {
                        slidesPerView: t.desktop,
                        slidesPerColumn: 1
                    }
                }
            }, t.options),
            n = this.slider.querySelector("[data-swiper-slider]"),
            a = new Swiper(n, o);
        a.on("init", (() => {
            a.update()
        })), a.init()
    }
}
customElements.define('swiper-slider', SwiperSlider);

class FeaturedSwiperSlider extends HTMLElement {
    constructor() {
        super(), this.slider = this.querySelector("[data-slider-options]"), this.init()
    }
    init() {
        const e = this.slider.getAttribute("data-slider-options");
        if (null === e || "" === e) return null;
        const t = $.extend(!0, {
                effect: "slide",
                direction: "horizontal",
                autoplay: !0,
                autoplaySpeed: 5,
                space: 30,
                center: !0,
                options: {}
            }, JSON.parse(e)),
            i = /^\d+$/;
        Object.keys(t).forEach((e => {
            "string" == typeof t[e] && i.test(t[e]) && (t[e] = parseInt(t[e], 10))
        }));
        let s = !1;
        t.auto_play > 0 && (s = {
            delay: 1e3 * t.auto_play
        });
        let l = !1,
            r = !1;
        "true" === t.loop || !0 === t.loop ? l = !0 : 1 === t.loop ? (l = !0, r = !0) : (r = !1, l = !1);
        const o = $.extend(!0, {
                init: !1,
                spaceBetween: t.gap,
                loop: l,
                autoplay: s,
                preventClicks: true,
                preventClicksPropagation: true,
                centeredSlides: r,
                navigation: {
                    nextEl: this.slider.querySelector(".swiper-button-next"),
                    prevEl: this.slider.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: this.slider.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                lazy: !0,
                focusableElements: 'input, select, option, textarea, video, label',
                breakpoints: {
                    320: {
                        slidesPerView: t.mobile,
                        spaceBetween: 15
                    },
                    576: {
                        slidesPerView: t.tablet
                    },
                    781: {
                        slidesPerView: t.laptop
                    },
                    1200: {
                        slidesPerView: t.desktop
                    }
                }
            }, t.options),
            n = this.slider.querySelector("[data-swiper-slider]"),
            a = new Swiper(n, o);
        a.on("init", (() => {
            a.update()
        })), a.init()
    }
}
customElements.define('featured-swiper-slider', FeaturedSwiperSlider);
class searchSlider extends HTMLElement {
    constructor() {
        super(),
        this.slider = this.querySelector("[data-slider-options]"),
        this.init();
    }
    init() {
        const e = this.slider.getAttribute("data-slider-options");
        if (null === e || "" === e) return null;
        const t = $.extend(!0, {
                effect: "slide",
                direction: "horizontal",
                autoplay: !0,
                autoplaySpeed: 5,
                space: 30,
                center: !0,
                options: {}
            }, JSON.parse(e)),
            i = /^\d+$/;
        Object.keys(t).forEach((e => {
            "string" == typeof t[e] && i.test(t[e]) && (t[e] = parseInt(t[e], 10))
        }));
        let s = !1;
        t.auto_play > 0 && (s = {
            delay: 1e3 * t.auto_play
        });
        let l = !1,
            r = !1;
        "true" === t.loop || !0 === t.loop ? l = !0 : 1 === t.loop ? (l = !0, r = !0) : (r = !1, l = !1);
        const o = $.extend(!0, {
                init: !1,
                loop: l,
                preventClicks: true,
                preventClicksPropagation: true,
                autoplay: s,
                spaceBetween: 30,
                centeredSlides: r,
                navigation: {
                    nextEl: this.slider.querySelector(".swiper-button-next"),
                    prevEl: this.slider.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: this.slider.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                lazy: !0,
                focusableElements: 'input, select, option, textarea, video, label',
                breakpoints: {
                    320: {
                        slidesPerView: t.mobile,
                    },
                    577: {
                        slidesPerView: t.tablet
                    },
                   781: {
                        slidesPerView: t.laptop
                    },
                    1200: {
                        slidesPerView: t.desktop
                    }
                }
            }, t.options),
            n = this.slider.querySelector("[data-swiper-slider]"),
            a = new Swiper(n, o);
        a.on("init", (() => {
            a.update()
        })), a.init()
    }
}
customElements.define('search-swiper-slider', searchSlider);
class upsellDrawer extends HTMLElement {
    constructor() {
        super(),
        this.slider = this.querySelector("[data-slider-options]"),
        this.init();
    }
    init() {
        const e = this.slider.getAttribute("data-slider-options");
        if (null === e || "" === e) return null;
        const t = $.extend(!0, {
                effect: "slide",
                direction: "horizontal",
                autoplay: !0,
                autoplaySpeed: 5,
                space: 30,
                center: !0,
                options: {}
            }, JSON.parse(e)),
            i = /^\d+$/;
        Object.keys(t).forEach((e => {
            "string" == typeof t[e] && i.test(t[e]) && (t[e] = parseInt(t[e], 10))
        }));
        let s = !1;
        t.auto_play > 0 && (s = {
            delay: 1e3 * t.auto_play
        });
        let l = !1,
            r = !1;
        "true" === t.loop || !0 === t.loop ? l = !0 : 1 === t.loop ? (l = !0, r = !0) : (r = !1, l = !1);
        const o = $.extend(!0, {
                init: !1,
                loop: l,
                preventClicks: true,
                preventClicksPropagation: true,
                autoplay: s,
                spaceBetween: 30,
                centeredSlides: false,
                navigation: {
                    nextEl: this.slider.querySelector(".swiper-button-next"),
                    prevEl: this.slider.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: this.slider.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                lazy: !0,
                focusableElements: 'input, select, option, textarea, video, label',
                breakpoints: {
                    320: {
                        slidesPerView: t.mobile,
                    },
                    577: {
                        slidesPerView: t.tablet
                    },
                   781: {
                        slidesPerView: t.laptop
                    },
                    1200: {
                        slidesPerView: t.desktop
                    }
                }
            }, t.options),
            n = this.slider.querySelector("[data-swiper-slider]"),
            a = new Swiper(n, o);
        a.on("init", (() => {
            a.update()
        })), a.init()
    }
}
customElements.define('upsell-slider', upsellDrawer);

class TestimonialVideoSwiperSlider extends HTMLElement {
       constructor() {
        super(), this.slider = this.querySelector("[data-slider-options]"), this.init()
    }
    init() {
        let e = this.slider.getAttribute("data-slider-options");
        if (null === e || "" === e) return null;
        let i = $.extend(!0, {
                effect: "slide",
                direction: "horizontal",
                autoplay: !0,
                autoplaySpeed: 5,
                space: 30,
                center: !0,
                options: {}
            }, JSON.parse(e)),
            t = /^\d+$/;
        Object.keys(i).forEach(e => {
            "string" == typeof i[e] && t.test(i[e]) && (i[e] = parseInt(i[e], 10))
        });
        let s = !1;
        i.auto_play > 0 && (s = {
            delay: 1e3 * i.auto_play
        });
        let l = !1,
            o = !1;
        "true" === i.loop || !0 === i.loop ? l = !0 : 1 === i.loop ? (l = !0, o = !0) : (o = !1, l = !1);
        let n = $.extend(!0, {
                init: !1,
                spaceBetween: i.gap,
                loop: l,
                autoplay: s,
                centeredSlides: o,
                navigation: {
                    nextEl: this.slider.querySelector(".swiper-button-next"),
                    prevEl: this.slider.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: this.slider.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                lazy: !0,
                breakpoints: {
                    320: {
                        slidesPerView: i.mobile,
                        slidesPerColumn: 1,
                        spaceBetween: 15
                    },
                    481: {
                        slidesPerView: i.tablet,
                        slidesPerColumn: 1
                    },
                    992: {
                        slidesPerView: i.laptop,
                        slidesPerColumn: 1
                    },
                    1541: {
                        slidesPerView: i.desktop,
                        slidesPerColumn: 1
                    }
                }
            }, i.options),
            r = this.slider.querySelector("[data-swiper-slider]"),
            a = new Swiper(r, n);
        a.on("init", () => {
            a.update()
        }), a.init()
    }
}
customElements.define('testimonial-video-swiper-slider', TestimonialVideoSwiperSlider);

class TeamSwiperSlider extends HTMLElement {
       constructor() {
        super(), this.slider = this.querySelector("[data-slider-options]"), this.init()
    }
    init() {
        let e = this.slider.getAttribute("data-slider-options");
        if (null === e || "" === e) return null;
        let i = $.extend(!0, {
                effect: "slide",
                direction: "horizontal",
                autoplay: !0,
                autoplaySpeed: 5,
                space: 30,
                center: !0,
                options: {}
            }, JSON.parse(e)),
            t = /^\d+$/;
        Object.keys(i).forEach(e => {
            "string" == typeof i[e] && t.test(i[e]) && (i[e] = parseInt(i[e], 10))
        });
        let s = !1;
        i.auto_play > 0 && (s = {
            delay: 1e3 * i.auto_play
        });
        let l = !1,
            o = !1;
        "true" === i.loop || !0 === i.loop ? l = !0 : 1 === i.loop ? (l = !0, o = !0) : (o = !1, l = !1);
        let n = $.extend(!0, {
                init: !1,
                spaceBetween: i.gap,
                loop: l,
                autoplay: s,
                centeredSlides: o,
                navigation: {
                    nextEl: this.slider.querySelector(".swiper-button-next"),
                    prevEl: this.slider.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: this.slider.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                lazy: !0,
                breakpoints: {
                    320: {
                        slidesPerView: i.mobile,
                        slidesPerColumn: 1,
                        spaceBetween: 15
                    },
                    481: {
                        slidesPerView: i.tablet,
                        slidesPerColumn: 1
                    },
                    768: {
                        slidesPerView: i.laptop,
                        slidesPerColumn: 1
                    },
                    1200: {
                        slidesPerView: i.desktop,
                        slidesPerColumn: 1
                    }
                }
            }, i.options),
            r = this.slider.querySelector("[data-swiper-slider]"),
            a = new Swiper(r, n);
        a.on("init", () => {
            a.update()
        }), a.init()
    }
}
customElements.define('team-swiper-slider', TeamSwiperSlider);

/*collection-list*/
class CollectionSlider extends HTMLElement {
    constructor() {
        super(), this.slider = this.querySelector("[data-slider-options]"), this.init()
    }
    init() {
        let e = this.slider.getAttribute("data-slider-options");
        if (null === e || "" === e) return null;
        let i = $.extend(!0, {
                direction: "horizontal",
                autoplay: !0,
                autoplaySpeed: 5,
                center: !0,
                options: {}
            }, JSON.parse(e)),
            t = /^\d+$/;
        Object.keys(i).forEach(e => {
            "string" == typeof i[e] && t.test(i[e]) && (i[e] = parseInt(i[e], 10))
        });
        let s = !1;
        i.auto_play > 0 && (s = {
            delay: 1e3 * i.auto_play
        });
        let l = !1,
            o = !1;
        "true" === i.loop || !0 === i.loop ? l = !0 : 1 === i.loop ? (l = !0, o = !0) : (o = !1, l = !1);
        let n = $.extend(!0, {
                init: !1,
                loop: l,
                autoplay: s,
                centeredSlides: o,
                effect: "coverflow",
                spaceBetween: 0,
                coverflowEffect: {
                    rotate: 0,
                    stretch: 0,
                    depth: 300,
                    modifier: 1,
                    slideShadows: !0
                },
                navigation: {
                    nextEl: this.slider.querySelector(".swiper-button-next"),
                    prevEl: this.slider.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: this.slider.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                lazy: !0,
                focusableElements: 'input, select, option, textarea, video, label',
                breakpoints: {
                    320: {
                        slidesPerView: i.mobile,
                        slidesPerColumn: 1
                    },
                    560: {
                        slidesPerView: i.tablet,
                        slidesPerColumn: 1
                    },
                    768: {
                        slidesPerView: i.desktop,
                        slidesPerColumn: 1
                    },
                    992: {
                        slidesPerView: i.desktop,
                        slidesPerColumn: 1

                    }
                }
            }, i.options),
            r = this.slider.querySelector("[data-collection-slider]"),
            a = new Swiper(r, n);
        a.on("init", () => {
            a.update()
        }), a.init()
    }
}
customElements.define("collection-slider", CollectionSlider);

class CollectionSwiperSlider extends HTMLElement {
    constructor() {
        super(), this.slider = this.querySelector("[data-slider-options]"), this.init()
    }
    init() {
        const e = this.slider.getAttribute("data-slider-options");
        if (null === e || "" === e) return null;
        const t = $.extend(!0, {
                effect: "slide",
                direction: "horizontal",
                autoplay: !0,
                autoplaySpeed: 5,
                center: !0,
                options: {}
            }, JSON.parse(e)),
            i = /^\d+$/;
        Object.keys(t).forEach((e => {
            "string" == typeof t[e] && i.test(t[e]) && (t[e] = parseInt(t[e], 10))
        }));
        let l = !1;
        t.auto_play > 0 && (l = {
            delay: 1e3 * t.auto_play
        });
        let s = !1,
            o = !1;
        "true" === t.loop || !0 === t.loop ? s = !0 : 1 === t.loop ? (s = !0, o = !0) : (o = !1, s = !1);
        const r = $.extend(!0, {
                init: !1,
                spaceBetween: t.gap,
                loop: s,
                autoplay: l,
                centeredSlides: o,
                navigation: {
                    nextEl: this.slider.querySelector(".swiper-button-next"),
                    prevEl: this.slider.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: this.slider.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                lazy: !0,
          focusableElements: 'input, select, option, textarea, video, label',
                breakpoints: {
                    320: {
                        slidesPerView: t.mobile,
                        slidesPerColumn: 1,
                         spaceBetween: 10
                    },
                    576: {
                        slidesPerView: t.tablet,
                        slidesPerColumn: 1
                    },
                    990: {
                        slidesPerView: t.laptop,
                        slidesPerColumn: 1
                    },
                    1440: {
                        slidesPerView: t.desktop,
                        slidesPerColumn: 1
                    }
                }
            }, t.options),
            n = this.slider.querySelector("[data-swiper-slider]"),
            p = new Swiper(n, r);
        p.on("init", (() => {
            p.update()
        })), p.init()
    }
}
customElements.define("collection-swiper-slider", CollectionSwiperSlider);
class Accordion {
    constructor(i) {
        this.el = i, this.summary = i.querySelector("summary"), this.content = i.querySelector(".accordion__content"), this.animation = null, this.isClosing = !1, this.isExpanding = !1, this.summary.addEventListener("click", (i => this.onClick(i)))
    }
    onClick(i) {
        i.preventDefault(), this.el.style.overflow = "hidden", this.isClosing || !this.el.open ? this.open() : (this.isExpanding || this.el.open) && this.shrink()
    }
    shrink() {
        this.isClosing = !0;
        const i = `${this.el.offsetHeight}px`,
            t = `${this.summary.offsetHeight}px`;
        this.animation && this.animation.cancel(), this.animation = this.el.animate({
            height: [i, t]
        }, {
            duration: 400,
            easing: "linear"
        }), this.animation.onfinish = () => this.onAnimationFinish(!1), this.animation.oncancel = () => this.isClosing = !1
    }
    open() {
        this.el.style.height = `${this.el.offsetHeight}px`, this.el.open = !0, window.requestAnimationFrame((() => this.expand()))
    }
    expand() {
        this.isExpanding = !0;
        const i = `${this.el.offsetHeight}px`,
            t = `${this.summary.offsetHeight+this.content.offsetHeight}px`;
        this.animation && this.animation.cancel(), this.animation = this.el.animate({
            height: [i, t]
        }, {
            duration: 400,
            easing: "linear"
        }), this.animation.onfinish = () => this.onAnimationFinish(!0), this.animation.oncancel = () => this.isExpanding = !1
    }
    onAnimationFinish(i) {
        this.el.open = i, this.animation = null, this.isClosing = !1, this.isExpanding = !1, this.el.style.height = this.el.style.overflow = ""
    }
}
document.querySelectorAll(".dt-details").forEach((i => {
    new Accordion(i)
}));
$("#accordian li").click((function() {
    var e = $(this),
        o = e.closest("ul"),
        t = o.find(".active"),
        i = e.closest("li"),
        l = i.hasClass("active"),
        s = 0;
    o.find("ul").slideUp((function() {
        ++s == o.find("ul").length && t.removeClass("active")
    })), l || (i.children("ul").slideDown(), i.addClass("active"))
}));


 if($(".footer-links").length > 0) {
  $(".footer-links").each(function() {
    $(this).on('click', function() {
       if ($(this).hasClass('open')) {
              $(this).removeClass('open');
            } else {
              $(this).addClass('open');
            }
    });
  });
 }
 if($(".footer_address").length > 0) {
    $(".footer_address").each(function() {
    $(this).on('click', function() {
       if ($(this).hasClass('open')) {
              $(this).removeClass('open');
            } else {
              $(this).addClass('open');
            }
    });
  });
  }



class InstaSlider extends HTMLElement {
    constructor() {
        super(), this.slider = this.querySelector("[data-slider-options]"), this.init()
    }
    init() {
        let e = this.slider.getAttribute("data-slider-options");
        if (null === e || "" === e) return null;
        let i = $.extend(!0, {
                effect: "slide",
                direction: "horizontal",
                autoplay: !0,
                autoplaySpeed: 5,
                space: 30,
                center: !0,
                options: {}
            }, JSON.parse(e)),
            t = /^\d+$/;
        Object.keys(i).forEach(e => {
            "string" == typeof i[e] && t.test(i[e]) && (i[e] = parseInt(i[e], 10))
        });
        let s = !1;
        i.auto_play > 0 && (s = {
            delay: 1e3 * i.auto_play
        });
        let l = !1,
            o = !1;
        "true" === i.loop || !0 === i.loop ? l = !0 : 1 === i.loop ? (l = !0, o = !0) : (o = !1, l = !1);
        let n = $.extend(!0, {
                init: !1,
                spaceBetween: i.gap,
                loop: l,
                autoplay: s,
                centeredSlides: o,
                navigation: {
                    nextEl: this.slider.querySelector(".swiper-button-next"),
                    prevEl: this.slider.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: this.slider.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                lazy: !0,
                breakpoints: {
                    320: {
                        slidesPerView: i.mobile,
                        slidesPerColumn: 1,
                        spaceBetween: 15
                    },
                    481: {
                        slidesPerView: i.tablet,
                        slidesPerColumn: 1
                    },
                    992: {
                        slidesPerView: i.laptop,
                        slidesPerColumn: 1
                    },
                    1200: {
                        slidesPerView: i.desktop,
                        slidesPerColumn: 1
                    }
                }
            }, i.options),
            r = this.slider.querySelector("[data-insta-slider]"),
            a = new Swiper(r, n);
        a.on("init", () => {
            a.update()
        }), a.init()
    }
}
customElements.define("insta-slider", InstaSlider);

class FlexSlider extends HTMLElement {
    constructor() {
        super(), this.slider = this.querySelector("[data-slider-options]"), this.init()
    }
    init() {
        let e = this.slider.getAttribute("data-slider-options");
        if (null === e || "" === e) return null;
        let i = $.extend(!0, {
                effect: "slide",
                direction: "horizontal",
                autoplay: !0,
                autoplaySpeed: 5,
                space: 30,
                center: !0,
                options: {}
            }, JSON.parse(e)),
            t = /^\d+$/;
        Object.keys(i).forEach(e => {
            "string" == typeof i[e] && t.test(i[e]) && (i[e] = parseInt(i[e], 10))
        });
        let s = !1;
        i.auto_play > 0 && (s = {
            delay: 1e3 * i.auto_play
        });
        let l = !1,
            o = !1;
        "true" === i.loop || !0 === i.loop ? l = !0 : 1 === i.loop ? (l = !0, o = !0) : (o = !1, l = !1);
        let n = $.extend(!0, {
                init: !1,
                spaceBetween: 0,
                loop: l,
                autoplay: s,
                centeredSlides: o,
                navigation: {
                    nextEl: this.slider.querySelector(".swiper-button-next"),
                    prevEl: this.slider.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: this.slider.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                lazy: !0,
                breakpoints: {
                    320: {
                        slidesPerView: 2,
                        slidesPerColumn: 1,
                        centeredSlides: false,
                    },
                    560: {
                        slidesPerView: 3,
                        slidesPerColumn: 1,
                        centeredSlides: false,
                    },
                    990: {
                        slidesPerView: 4,
                        slidesPerColumn: 1
                    }
                }
            }, i.options),
            r = this.slider.querySelector("[data-flex-slider]"),
            a = new Swiper(r, n);
        a.on("init", () => {
            a.update()
        }), a.init()
    }
}
customElements.define("flex-slider", FlexSlider);


class RecommendationSlider extends HTMLElement {
    constructor() {
        super(), this.slider = this.querySelector("[data-slider-options]"), this.init()
    }
    init() {
        const e = this.slider.getAttribute("data-slider-options");
        if (null === e || "" === e) return null;
        const t = $.extend(!0, {
                effect: "slide",
                direction: "horizontal",
                autoplay: !0,
                autoplaySpeed: 5,
                space: 30,
                center: !0,
                options: {}
            }, JSON.parse(e)),
            i = /^\d+$/;
        Object.keys(t).forEach((e => {
            "string" == typeof t[e] && i.test(t[e]) && (t[e] = parseInt(t[e], 10))
        }));
        let s = !1;
        t.auto_play > 0 && (s = {
            delay: 1e3 * t.auto_play
        });
        let l = !1,
            r = !1;
        "true" === t.loop || !0 === t.loop ? l = !0 : 1 === t.loop ? (l = !0, r = !0) : (r = !1, l = !1);
        const o = $.extend(!0, {
                init: !1,
                spaceBetween: t.gap,
                loop: l,
                autoplay: s,
                preventClicks: true,
                preventClicksPropagation: true,
                centeredSlides: r,
                navigation: {
                    nextEl: this.slider.querySelector(".swiper-button-next"),
                    prevEl: this.slider.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: this.slider.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                lazy: !0,
                focusableElements: 'input, select, option, textarea, video, label',
                breakpoints: {
                    320: {
                        slidesPerView: t.mobile,
                        slidesPerColumn: 1
                    },
                    576: {
                        slidesPerView: t.tablet,
                        slidesPerColumn: 1
                    },
                    990: {
                        slidesPerView: t.laptop,
                        slidesPerColumn: 1
                    },
                    1541: {
                        slidesPerView: t.desktop,
                        slidesPerColumn: 1
                    }
                }
            }, t.options),
            n = this.slider.querySelector("[data-swiper-slider]"),
            a = new Swiper(n, o);
        a.on("init", (() => {
            a.update()
        })), a.init()
    }
}
customElements.define('recommendation-slider', RecommendationSlider);




// let currentTabTitle = document.title
// document.addEventListener("visibilitychange", function () {
// 	document.visibilityState === "hidden" ? (document.title = `Do not leave me 😭`): (document.title = currentTabTitle)
// })


class MultiSlider extends HTMLElement {
    constructor() {
        super(), this.slider = this.querySelector("[data-slider-options]"), this.init()
    }
    init() {
        const e = this.slider.getAttribute("data-slider-options");
        if (null === e || "" === e) return null;
        const t = $.extend(!0, {
                effect: "slide",
                direction: "horizontal",
                autoplay: !0,
                autoplaySpeed: 5,
                space: 30,
                center: !0,
                options: {}
            }, JSON.parse(e)),
            i = /^\d+$/;
        Object.keys(t).forEach((e => {
            "string" == typeof t[e] && i.test(t[e]) && (t[e] = parseInt(t[e], 10))
        }));
        let s = !1;
        t.auto_play > 0 && (s = {
            delay: 1e3 * t.auto_play
        });
        let l = !1,
            r = !1;
        "true" === t.loop || !0 === t.loop ? l = !0 : 1 === t.loop ? (l = !0, r = !0) : (r = !1, l = !1);
        const o = $.extend(!0, {
                init: !1,
                spaceBetween: t.gap,
                loop: l,
                preventClicks: true,
          preventClicksPropagation: true,
                autoplay: s,
                centeredSlides: r,
                navigation: {
                    nextEl: this.slider.querySelector(".swiper-button-next"),
                    prevEl: this.slider.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: this.slider.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                lazy: !0,
                focusableElements: 'input, select, option, textarea, video, label',
                breakpoints: {
                    320: {
                        slidesPerView: t.mobile,
                        slidesPerColumn: 1
                    },
                    577: {
                        slidesPerView: t.tablet,
                        slidesPerColumn: 1
                    },
                    991: {
                        slidesPerView: t.laptop,
                        slidesPerColumn: 1
                    },
                    1200: {
                        slidesPerView: t.desktop,
                        slidesPerColumn: 1
                    }
                }
            }, t.options),
            n = this.slider.querySelector("[data-swiper-slider]"),
            a = new Swiper(n, o);
        a.on("init", (() => {
            a.update()
        })), a.init()
    }
}
customElements.define('multi-slider', MultiSlider);

class BlogSlider extends HTMLElement {
    constructor() {
        super(), this.slider = this.querySelector("[data-slider-options]"), this.init()
    }
    init() {
        const e = this.slider.getAttribute("data-slider-options");
        if (null === e || "" === e) return null;
        const t = $.extend(!0, {
                effect: "slide",
                direction: "horizontal",
                autoplay: !0,
                autoplaySpeed: 5,
                space: 30,
                center: !0,
                options: {}
            }, JSON.parse(e)),
            i = /^\d+$/;
        Object.keys(t).forEach((e => {
            "string" == typeof t[e] && i.test(t[e]) && (t[e] = parseInt(t[e], 10))
        }));
        let s = !1;
        t.auto_play > 0 && (s = {
            delay: 1e3 * t.auto_play
        });
        let l = !1,
            r = !1;
        "true" === t.loop || !0 === t.loop ? l = !0 : 1 === t.loop ? (l = !0, r = !0) : (r = !1, l = !1);
        const o = $.extend(!0, {
                init: !1,
                spaceBetween: t.gap,
                loop: l,
                preventClicks: true,
          preventClicksPropagation: true,
                autoplay: s,
                centeredSlides: r,
                navigation: {
                    nextEl: this.slider.querySelector(".swiper-button-next"),
                    prevEl: this.slider.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: this.slider.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                lazy: !0,
                focusableElements: 'input, select, option, textarea, video, label',
                breakpoints: {
                    320: {
                        slidesPerView: t.mobile,
                        slidesPerColumn: 1
                    },
                    577: {
                        slidesPerView: t.tablet,
                        slidesPerColumn: 1
                    },
                    990: {
                        slidesPerView: t.laptop,
                        slidesPerColumn: 1
                    },
                    1200: {
                        slidesPerView: t.desktop,
                        slidesPerColumn: 1
                    }
                }
            }, t.options),
            n = this.slider.querySelector("[data-swiper-slider]"),
            a = new Swiper(n, o);
        a.on("init", (() => {
            a.update()
        })), a.init()
    }
}
customElements.define('blog-slider', BlogSlider);

class SupportSlider extends HTMLElement {
    constructor() {
        super(), this.slider = this.querySelector("[data-slider-options]"), this.init()
    }
    init() {
        const e = this.slider.getAttribute("data-slider-options");
        if (null === e || "" === e) return null;
        const t = $.extend(!0, {
                effect: "slide",
                direction: "horizontal",
                autoplay: !0,
                autoplaySpeed: 5,
                space: 30,
                center: !0,
                options: {}
            }, JSON.parse(e)),
            i = /^\d+$/;
        Object.keys(t).forEach((e => {
            "string" == typeof t[e] && i.test(t[e]) && (t[e] = parseInt(t[e], 10))
        }));
        let s = !1;
        t.auto_play > 0 && (s = {
            delay: 1e3 * t.auto_play
        });
        let l = !1,
            r = !1;
        "true" === t.loop || !0 === t.loop ? l = !0 : 1 === t.loop ? (l = !0, r = !0) : (r = !1, l = !1);
        const o = $.extend(!0, {
                init: !1,
                spaceBetween: t.gap,
                loop: l,
                preventClicks: true,
          preventClicksPropagation: true,
                autoplay: s,
                centeredSlides: r,
                navigation: {
                    nextEl: this.slider.querySelector(".swiper-button-next"),
                    prevEl: this.slider.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: this.slider.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                lazy: !0,
                focusableElements: 'input, select, option, textarea, video, label',
                breakpoints: {
                    320: {
                        slidesPerView: t.mobile,
                        slidesPerColumn: 1
                    },
                    560: {
                        slidesPerView: t.tablet,
                        slidesPerColumn: 1
                    },
                    992: {
                        slidesPerView: t.laptop,
                        slidesPerColumn: 1
                    },
                    1200: {
                        slidesPerView: t.desktop,
                        slidesPerColumn: 1
                    }
                }
            }, t.options),
            n = this.slider.querySelector("[data-swiper-slider]"),
            a = new Swiper(n, o);
        a.on("init", (() => {
            a.update()
        })), a.init()
    }
}
customElements.define('support-slider', SupportSlider);

class GridSlider extends HTMLElement {
    constructor() {
        super(), this.slider = this.querySelector("[data-slider-options]"), this.init()
    }
    init() {
        const e = this.slider.getAttribute("data-slider-options");
        if (null === e || "" === e) return null;
        const t = $.extend(!0, {
                effect: "slide",
                direction: "horizontal",
                autoplay: !0,
                autoplaySpeed: 5,
                space: 30,
                center: !0,
                options: {}
            }, JSON.parse(e)),
            i = /^\d+$/;
        Object.keys(t).forEach((e => {
            "string" == typeof t[e] && i.test(t[e]) && (t[e] = parseInt(t[e], 10))
        }));
        let s = !1;
        t.auto_play > 0 && (s = {
            delay: 1e3 * t.auto_play
        });
        let l = !1,
            r = !1;
        "true" === t.loop || !0 === t.loop ? l = !0 : 1 === t.loop ? (l = !0, r = !0) : (r = !1, l = !1);
        const o = $.extend(!0, {
                init: !1,
                spaceBetween: t.gap,
                loop: l,
                preventClicks: true,
          preventClicksPropagation: true,
                autoplay: s,
                centeredSlides: r,
                navigation: {
                    nextEl: this.slider.querySelector(".swiper-button-next"),
                    prevEl: this.slider.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: this.slider.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                lazy: !0,
                focusableElements: 'input, select, option, textarea, video, label',
                breakpoints: {
                    320: {
                        slidesPerView: t.mobile,
                        slidesPerColumn: 1
                    },
                    576: {
                        slidesPerView: t.tablet,
                        slidesPerColumn: 1
                    },
                     991: {
                        slidesPerView: t.laptop,
                        slidesPerColumn: 1
                    },
                    1200: {
                        slidesPerView: t.desktop,
                        slidesPerColumn: 1
                    }
                }
            }, t.options),
            n = this.slider.querySelector("[data-swiper-slider]"),
            a = new Swiper(n, o);
        a.on("init", (() => {
            a.update()
        })), a.init()
    }
}
customElements.define('grid-slider', GridSlider);
/*Reveal*/
const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting){
            entry.target.classList.add('reveal');
        }
    });
});
const hiddenElements = document.querySelectorAll('.shopify-section');
hiddenElements.forEach((el) => observer.observe(el));


document.querySelectorAll('[id^="shopify-section-"]').forEach((card, index) => {
   if(card.classList.contains('section-featured-collection') || card.classList.contains('section-collection-list')) {
    const topHeading = card.querySelectorAll('.for-arrow-alignment');
    if(topHeading.length === 0) return;
    const cardHeight = parseInt(topHeading[0].clientHeight);
    const topValue = cardHeight / 2 + 5;
    const cardTopCSS = "calc(50% - "+topValue+'px)';
    const swiperContainer = card.querySelector('.swiper');
    if(!swiperContainer) return;
    const swiperPrevElement = swiperContainer.querySelector('.swiper-button-prev');
    const swiperNextElement = swiperContainer.querySelector('.swiper-button-next');
    if(!swiperPrevElement || !swiperNextElement) return
    swiperPrevElement.setAttribute('style', 'top:'+cardTopCSS);
    swiperNextElement.setAttribute('style', 'top:'+cardTopCSS);

  }
});


document.querySelectorAll('[id^="block-tab-1"]').forEach((arrowTab, index) => {
   if(arrowTab.classList.contains('product-tab-carousel')) {
    const topHeading = arrowTab.querySelectorAll('.for-arrow-alignment');
    if(topHeading.length === 0) return;
    const cardHeight = parseInt(topHeading[0].clientHeight);
    const topValue = cardHeight / 2 + 5;
    const cardTopCSS = "calc(50% - "+topValue+'px)';
    const swiperContainer = arrowTab.querySelector('.swiper-container');
    if(!swiperContainer) return;
    const swiperPrevElement = swiperContainer.querySelector('.swiper-button-prev');
    const swiperNextElement = swiperContainer.querySelector('.swiper-button-next');
     if(!swiperPrevElement || !swiperNextElement) return
    swiperPrevElement.setAttribute('style', 'top:'+cardTopCSS);
    swiperNextElement.setAttribute('style', 'top:'+cardTopCSS);
  }
});


class complementarySlider extends HTMLElement {
            constructor() {
                super(), this.slider = this.querySelector("[data-slider-options]"), this.init()
            }
            init() {
        const e = this.slider.getAttribute("data-slider-options");
        if (null === e || "" === e) return null;
        const t = $.extend(!0, {
                effect: "slide",
                direction: "horizontal",
                autoplay: !0,
                autoplaySpeed: 5,
                space: 30,
                center: !0,
                options: {}
            }, JSON.parse(e)),
            i = /^\d+$/;
        Object.keys(t).forEach((e => {
            "string" == typeof t[e] && i.test(t[e]) && (t[e] = parseInt(t[e], 10))
        }));
        let s = !1;
        t.auto_play > 0 && (s = {
            delay: 1e3 * t.auto_play
        });
        let l = !1,
            r = !1;
        "true" === t.loop || !0 === t.loop ? l = !0 : 1 === t.loop ? (l = !0, r = !0) : (r = !1, l = !1);
        const o = $.extend(!0, {
                init: !1,
                loop: l,
                autoplay: s,
                preventClicks: true,
                preventClicksPropagation: true,
                centeredSlides: false,
                navigation: {
                    nextEl: this.slider.querySelector(".swiper-button-next"),
                    prevEl: this.slider.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: this.slider.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                lazy: !0,
                focusableElements: 'input, select, option, textarea, video, label',
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 10,
                    },
                    576: {
                        slidesPerView: 1,
                        spaceBetween: 10,
                    },
                    781: {
                        slidesPerView: 1,
                        spaceBetween: 10,
                    },
                    1200: {
                        slidesPerView: 2,
                         spaceBetween: 10,
                    }
                }
            }, t.options),
            n = this.slider.querySelector("[data-swiper-slider]"),
            a = new Swiper(n, o);
        a.on("init", (() => {
            a.update()
        })), a.init()
    }
}
customElements.define('complementary-slider', complementarySlider);


const copyText = document.getElementById('copy__text');
if (copyText !== null) {
copyText.querySelector("button").addEventListener("click", function () {
let input = copyText.querySelector("input.text");
input.select();
document.execCommand("copy");
copyText.classList.add("active");
window.getSelection().removeAllRanges();
setTimeout(function () {
  copyText.classList.remove("active");
}, 2500);
});
}


class marqueeSwiper extends HTMLElement {
  constructor() {
   super();
   const marqueeContainer = this.querySelector('[id^="dt-marquee-section-"]');
   let speed = parseInt(marqueeContainer.getAttribute('data-speed'));
    var mySwiper = new Swiper(marqueeContainer, {
    spaceBetween: 0,
    centeredSlides: true,
    speed: speed,
    autoplay: {
       delay: 0,
         disableOnInteraction: false,
         pauseOnMouseEnter: true,
    },
    loop: true,
    slidesPerView:'auto',
    allowTouchMove: false
    });
    marqueeContainer.addEventListener('mouseenter', function(e) {
      $('.dt-animate-call').addClass('start-animation');
    });
    marqueeContainer.addEventListener('mouseleave', function(e) {
       $('.dt-animate-call').removeClass('start-animation');
    });
}
}
customElements.define('marquee-slider', marqueeSwiper);

const accountModel = document.getElementById('login-modal__window');
const accountButton = document.querySelector('.header__icon--account');
if (accountButton) {
    const accountClose = document.querySelector('.details-modal-close');
    accountButton.addEventListener("click", function (e) {
        accountModel.classList.toggle('login-modal-active');
    });
    if (accountClose) {
        accountClose.addEventListener("click", function (e) {
            accountModel.classList.remove('login-modal-active');
        });
    }
}

$(document).ready(function() {
    function setDivHeight() {
        // Check screen width
        if ($(window).width() >= 990) {
            $('.product--thumbnail_slider').each(function() {
                var windowHeight = $(this).find(".GalleryViewerMain").height();
                $(this).find('.GalleryThumbnails').height(windowHeight);
            });
        }
    }

    // Call setDivHeight on page load
    setDivHeight();

    // Call setDivHeight on window resize
    $(window).resize(function() {
        setDivHeight();
    });
});




//Collection list

if (!customElements.get('colletion-list')) {
  customElements.define('colletion-list', class WDT_Swiper extends HTMLElement{
    constructor() {
        super();
        this.sliderConfigElement = this.querySelector("[data-slider-options]");
        if (this.sliderConfigElement) this.initializeSlider();
    }

    initializeSlider() {
        const sliderOptionsData = this.sliderConfigElement.getAttribute("data-slider-options");
        if (!sliderOptionsData) return;
        const sliderOptions = $.extend(true, {
            effect: "slide",
            direction: "horizontal",
            autoplay: true,
            autoplaySpeed: 5,
            grabCursor: false,
            spaceBetween: 0,
            additionalOptions: {}
        }, JSON.parse(sliderOptionsData));

        const numericPattern = /^\d+$/;
        Object.keys(sliderOptions).forEach((key) => {
            if (typeof sliderOptions[key] === "string" && numericPattern.test(sliderOptions[key])) {
                sliderOptions[key] = parseInt(sliderOptions[key], 10);
            }
        });


        const autoplaySettings = sliderOptions.auto_play > 0 ? { delay: 1000 * sliderOptions.auto_play } : false;
        const loopEnabled = sliderOptions.loop === "true" || sliderOptions.loop === true;
        const centeredSlides = sliderOptions.mode === "true" || sliderOptions.mode === true;

        const swiperOptions = $.extend(true, {
            init: false,
            spaceBetween: sliderOptions.space,
            loop: loopEnabled,
            preventClicks: true,
            preventClicksPropagation: true,
            autoplay: autoplaySettings,
            centeredSlides: centeredSlides,
            speed: 2000,
            navigation: {
                nextEl: this.sliderConfigElement.querySelector(".swiper-button-next"),
                prevEl: this.sliderConfigElement.querySelector(".swiper-button-prev")
            },
            pagination: {
                el: this.sliderConfigElement.querySelector(".swiper-pagination"),
                clickable: true
            },
            lazy: true,
            focusableElements: 'input, select, option, textarea, video, label',
            breakpoints: {
                320: {
                    slidesPerView: sliderOptions.mobile || 1,
                    spaceBetween: sliderOptions.space * 0.5
                },
                768: {
                    slidesPerView: sliderOptions.tablet || 2,
                    spaceBetween: sliderOptions.space * 0.7
                },
                1024: {
                    slidesPerView: sliderOptions.laptop || 3,
                    spaceBetween: sliderOptions.space * 0.8
                },
                1400: {
                    slidesPerView: sliderOptions.desktop || 4
                }
            }
        }, sliderOptions.additionalOptions);


        const swiperContainer = this.sliderConfigElement.querySelector("[data-swiper-slider]");
        const swiperInstance = new Swiper(swiperContainer, swiperOptions);
        swiperInstance.on("init", () => {
            swiperInstance.update();
        });

        swiperInstance.init();
    }
});
}

// product copy URL button

document.addEventListener('click', function (event) {
  const button = event.target.closest('.copy-url-btn');
  if (button) {
    const inputGroup = button.closest('.input-group');
    if (!inputGroup) return;
    const input = inputGroup.querySelector('.productUrl');
    const url = input ? input.value : '';
    if (url) {
      navigator.clipboard.writeText(url).then(() => {
        const originalText = button.textContent;
        button.textContent = 'Copied!';
        setTimeout(() => {
          button.textContent = originalText;
        }, 2000);
      });
    }
  }
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    setTimeout(() => {
      document.querySelectorAll('slider-component').forEach((slider) => {

        slider.slider = slider.querySelector('[id^="Slider-"]');
        slider.sliderItems = slider.querySelectorAll('[id^="Slide-"]');

        if (!slider.slider || !slider.sliderItems.length) return;

        slider.initPages();
        slider.update();

        slider.slider.scrollLeft = 0;

        window.dispatchEvent(new Event('resize'));
      });
    }, 1);
  });
}

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.loadRecommendations(this.dataset.productId);
  }

  loadRecommendations(productId) {
      fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
          .then(response => response.text())
          .then(text => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(text, 'text/html');
              const recommendations = doc.querySelector("product-recommendations");
              const recommendationItems = doc.querySelector(".recommendation-items");
              const complementaryItems = doc.querySelector(".complementary-items");
              if (recommendations && recommendations.hasChildNodes()) {
                  while (this.firstChild) {
                      this.removeChild(this.firstChild);
                  }
                  Array.from(recommendations.children).forEach(child => {
                      this.appendChild(child.cloneNode(true));
                  });
              }
              if (recommendationItems) {
                  $(".related-products").closest(".shopify-section").removeClass("d-none");
                  this.classList.add("product-recommendations--loaded");
                  this.initSlider();
              }

              if (complementaryItems) {
                  this.classList.add("product-complementary--loaded");
                  this.complementarySlider();
              }

              cardVariantSwatch();
              this.initQuickViewButtons();
          })
          .catch(() => {
          });
  }


  initSlider() {
    const slider = this.querySelector("[data-swiper-slider]");
    const sliderList = this.querySelectorAll(".recommendation-items");
    if (!slider || sliderList.length === 0) return;

    const sliderOptions = slider.parentElement.getAttribute("data-slider-options");
    if (!sliderOptions) {
      return;
    }

    const options = JSON.parse(sliderOptions);
    const parsedOptions = this.parseSliderOptions(options);

    new Swiper(slider, {
      loop: parsedOptions.loop,
      autoplay: parsedOptions.autoplay ? { delay: parsedOptions.autoplay, disableOnInteraction: false } : false,
      centeredSlides: parsedOptions.centeredSlides,
      navigation: {
        nextEl: slider.parentElement.querySelector(".swiper-button-next"),
        prevEl: slider.parentElement.querySelector(".swiper-button-prev"),
      },
      pagination: {
        el: slider.parentElement.querySelector(".swiper-pagination"),
        clickable: true,
        // renderBullet: (index, className) => `<span class="${className} page-link rounded-circle m-1 p-1"></span>`,
      },
      lazy: { loadOnTransitionStart: true },
      slidesPerView: parsedOptions.slidesToShow,
      spaceBetween: parsedOptions.spaceBetween,
      speed: 2000,
       breakpoints: {
                320: {
                    slidesPerView: options.mobile || 1,
                    spaceBetween: options.space * 0.5
                },
                480: {
                    slidesPerView: options.medium_down || 2,
                    spaceBetween: options.space * 0.7
                },
                768: {
                    slidesPerView: options.tablet || 2,
                    spaceBetween: options.space * 0.7
                },
                992: {
                    slidesPerView: options.laptop || 3,
                    spaceBetween: options.space * 0.8
                },
                1400: {
                    slidesPerView: options.desktop || 4
                }
            }
    });
  }

  parseSliderOptions(options) {
    Object.keys(options).forEach(key => {
      if (typeof options[key] === "string" && /^\d+$/.test(options[key])) {
        options[key] = parseInt(options[key], 10);
      }
    });

    return {
      autoplay: options.auto_play > 0 ? options.auto_play * 1000 : false,
      loop: options.loop === "true" || options.loop === true,
      centeredSlides: options.mode === "true" || options.mode === true,
      pagination: options.dots === "true" || options.dots === true,
      slidesToShow: options.desktop,
      spaceBetween: options.space,
    };
  }

  complementarySlider() {
    const complementaryContainer = document.getElementById("complementary-slideshow");
    if (!complementaryContainer) return;

    new Swiper(complementaryContainer, {
      // loop: true,
      // autoplay: {
      //   delay: 3000,
      //   pauseOnMouseEnter: true,
      // },
      spaceBetween: 30,
      speed: 2000,
       breakpoints: {
      992: {
      slidesPerView:3,
      },
      1400: {
      slidesPerView: 3
      }
      },
      navigation: {
        nextEl: complementaryContainer.parentElement.querySelector('.swiper-button-next'),
        prevEl: complementaryContainer.parentElement.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: complementaryContainer.parentElement.querySelector(".swiper-pagination"),
        clickable: true,
      },
    });
  }

  //QuickBTNS
  initQuickViewButtons() {
  const quickViewButtons = this.querySelectorAll('.quick-view-btn');
   quickViewButtons.forEach(button => {
  button.addEventListener('click', () => {

    const offcanvasElement = document.getElementById('quickViewOffcanvas');
  const offcanvasInstance = bootstrap.Offcanvas.getInstance(offcanvasElement);

  // Check if the offcanvas is open and the click is outside of the offcanvas
  if (offcanvasInstance && offcanvasInstance._isShown && !offcanvasElement.contains(event.target)) {
    offcanvasInstance.hide(); // Hide the offcanvas
  }

    const productUrl = button.getAttribute('data-product-url');
    const quickViewContent = document.getElementById('quickViewContent'); // Offcanvas body content
    quickViewContent.textContent = 'Loading...';
    isQuickViewOpen = true;
    // Fetch product data
    fetch(productUrl)
      .then(response => response.text())
      .then(data => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, 'text/html');
        const productInfoElement = doc.querySelector('product-template');

        if (productInfoElement && productInfoElement.hasChildNodes() ) {
          updateDOM(productInfoElement);
          quickViewContent.replaceChildren();
            Array.from(productInfoElement.children).forEach(child => {
              quickViewContent.appendChild(child.cloneNode(true));
            });

          var offcanvasElement = document.getElementById('quickViewOffcanvas')
          if(!offcanvasElement) return;
          const quickViewOffcanvas = new bootstrap.Offcanvas(offcanvasElement);
          quickViewOffcanvas.show();
          quickViewOffcanvas.show();
          this.initializeModalContent(quickViewContent);

        } else {
          quickViewContent.textContent = 'Product information not found.';
        }
      })
      .catch(error => {
        quickViewContent.textContent = 'Sorry, an error occurred while loading the product.';
      });
  });
});

}

initializeModalContent(modalContent) {
  if (modalContent) {
    new ProductGallery(modalContent);
    const variantSelectors = modalContent.querySelectorAll('variant-selector');
    variantSelectors.forEach((variantSelectorEl) => {
      if (typeof variantSelectorEl.init === 'function') {
        variantSelectorEl.init(modalContent);
      } else {
        const variantSelector = new VariantSelector(modalContent);
        if (typeof variantSelector.init === 'function') {
          variantSelector.init(modalContent);
        }
      }
    });
  }
}


});
}

window.HotspotTooltip = (() => {
  const alignmentMap = {
    start: 'start',
    center: 'center',
    end: 'end',
  };

  const positionMap = {
    start: 'start',
    center: 'center',
    end: 'end',
    between: 'space-between',
  };

  const ratioMap = {
    portrait: '3/4',
    square: '1/1',
    landscape: '4/3',
    adapt: 'auto',
  };

  let currentIsMobile = window.matchMedia('(max-width: 768px)').matches;
  let initTimeout = null;
  let observer = null;
  let customizerCheckInterval = null;
  let initialized = false;

  function createTooltipContent(obj) {
  const direction = obj.direction || 'column';
  const align = alignmentMap[obj.align] || 'flex-start';
  const contentPosition = positionMap[obj.content_position] || 'center';
  const ratio = ratioMap[obj.ratio] || '3/4';

  const image =
    obj.image && obj.image !== 'placeholder'
      ? obj.image
      : 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png?v=1530129081';

  const title = obj.title || 'Product Title';
  const price = obj.price || '$19.00';

  return `
    <div class="tooltip-content p-2"
      style="display:flex;flex-direction:${direction};
      align-items:${contentPosition};gap:10px;">

      <a href="${obj.url || '#'}" style="flex-shrink:1;">
        <img
          src="${image}"
          alt="${title}"
          style="
            object-fit:cover;
            width:70px;
            aspect-ratio:${ratio};
            margin-bottom:5px;
          "
        >
      </a>

      <div
        style="
          display:flex;
          flex-direction:column;
          align-items:${align};
        "
      >
        <h6
          class="tooltip-content-block"
          style="text-align:${align};color:black;"
        >
          <a href="${obj.url || '#'}">
            ${title}
          </a>
        </h6>

        <p class="m-0" style="color:red;">
          ${price}
        </p>
      </div>
    </div>
  `;
}

  function initHotspots(scope = document) {
    if (typeof tippy === 'undefined') {
      console.warn('Tippy.js is not loaded.');
      return;
    }

    scope.querySelectorAll('.hotspot-red').forEach((el) => {
      if (el._tippy && !el._needsReinit) return;

      if (el._tippy) {
        el._tippy.destroy();
        el._tippy = null;
      }

      const data = el.getAttribute('data-tooltip');

      if (!data) return;

      let content = '';

      try {
        const obj = JSON.parse(data);
        content = createTooltipContent(obj);
      } catch (e) {
        console.error('Invalid tooltip JSON:', e);
        content = data;
      }

      try {
        tippy(el, {
          appendTo: document.body,
          content,
          allowHTML: true,
          interactive: true,
          trigger: 'click',
          flip: false,
          offset: [0, 10],
          maxWidth: currentIsMobile ? 250 : 500,
          placement: currentIsMobile ? 'bottom' : 'left',
        });

        el._needsReinit = false;
      } catch (error) {
        console.error('Tippy init error:', error);
      }
    });
  }

  function debouncedInit() {
    clearTimeout(initTimeout);

    initTimeout = setTimeout(() => {
      document.querySelectorAll('.hotspot-red').forEach((el) => {
        el._needsReinit = true;
      });

      initHotspots();

      initTimeout = null;
    }, 150);
  }

  function handleResize() {
    const isNowMobile = window.matchMedia(
      '(max-width: 768px)'
    ).matches;

    if (isNowMobile !== currentIsMobile) {
      currentIsMobile = isNowMobile;

      document.querySelectorAll('.hotspot-red').forEach((el) => {
        el._needsReinit = true;
      });

      initHotspots();
    }
  }

  function observeDomChanges() {
    if (observer) observer.disconnect();

    observer = new MutationObserver((mutations) => {
      let shouldReinit = false;

      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach((node) => {
            if (
              node.nodeType === 1 &&
              (
                node.classList?.contains('hotspot-red') ||
                node.querySelector?.('.hotspot-red')
              )
            ) {
              shouldReinit = true;
            }
          });
        }

        if (
          mutation.type === 'attributes' &&
          mutation.target.classList?.contains('hotspot-red') &&
          mutation.attributeName === 'data-tooltip'
        ) {
          shouldReinit = true;
        }
      });

      if (shouldReinit) {
        debouncedInit();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-tooltip', 'class'],
    });
  }

  function bindShopifyEvents() {
    const events = [
      'shopify:section:load',
      'shopify:section:reorder',
      'shopify:section:select',
      'shopify:section:deselect',
      'shopify:block:select',
      'shopify:block:deselect',
    ];

    events.forEach((eventName) => {
      document.addEventListener(eventName, debouncedInit);
    });
  }

  function startCustomizerWatcher() {
    if (
      typeof Shopify !== 'undefined' &&
      Shopify.designMode
    ) {
      customizerCheckInterval = setInterval(() => {
        const hasUninitialized = [
          ...document.querySelectorAll('.hotspot-red'),
        ].some((el) => !el._tippy || el._needsReinit);

        if (hasUninitialized) {
          debouncedInit();
        }
      }, 2000);
    }
  }

  function destroy() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }

    clearTimeout(initTimeout);

    if (customizerCheckInterval) {
      clearInterval(customizerCheckInterval);
      customizerCheckInterval = null;
    }

    document.querySelectorAll('.hotspot-red').forEach((el) => {
      if (el._tippy) {
        el._tippy.destroy();
        el._tippy = null;
      }
    });

    initialized = false;
  }

  function init() {
    if (initialized) return;
initialized = true;

    initHotspots();

    const resizeMediaQuery = window.matchMedia(
      '(max-width: 768px)'
    );

    if (resizeMediaQuery.addEventListener) {
      resizeMediaQuery.addEventListener(
        'change',
        handleResize
      );
    } else {
      resizeMediaQuery.addListener(handleResize);
    }

    observeDomChanges();
    bindShopifyEvents();
    startCustomizerWatcher();
  }

  return {
    init,
    destroy,
    refresh: debouncedInit,
  };
})();

document.addEventListener('DOMContentLoaded', () => {
  window.HotspotTooltip.init();
});

//marquee function

document.querySelectorAll('.marquee_container').forEach((container) => {
  const marquee = container.querySelector('.marquee-list');

  if (marquee) {
    container.style.setProperty(
      '--marquee-width',
      marquee.scrollWidth
    );
  }
});

//Hotspot

window.HotspotSlider = (() => {
  function init(sectionElement) {
    if (!sectionElement) return;

    const sliders = sectionElement.querySelectorAll('[data-hotspot-slider]');

    sliders.forEach((slider) => {
      /* Destroy existing swiper */
      if (slider.swiper) {
        slider.swiper.destroy(true, true);
      }

      const sectionId = slider.dataset.sectionId;

      const totalSlides =
        slider.querySelectorAll('.swiper-slide').length;

      const hasMultiple = totalSlides > 1;

      const swiper = new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: false,

        navigation: hasMultiple
          ? {
              nextEl: sectionElement.querySelector(
                `[data-hotspot-next="${sectionId}"]`
              ),

              prevEl: sectionElement.querySelector(
                `[data-hotspot-prev="${sectionId}"]`
              ),
            }
          : false,

        pagination: hasMultiple
          ? {
              el: sectionElement.querySelector(
                `[data-hotspot-pagination="${sectionId}"]`
              ),

              clickable: true,
            }
          : false,

        on: {
          slideChange() {
            updateActiveDot(
              sectionElement,
              sectionId,
              this.activeIndex
            );
          },
        },
      });

      const dots = sectionElement.querySelectorAll(
        `[data-hotspot-dot="${sectionId}"]`
      );

      dots.forEach((dot) => {
        dot.onclick = () => {
          const index = Number(dot.dataset.index);

          swiper.slideTo(index);

          updateActiveDot(
            sectionElement,
            sectionId,
            index
          );
        };
      });

      if (dots.length) {
        updateActiveDot(sectionElement, sectionId, 0);
      }
    });
  }

  function updateActiveDot(
    sectionElement,
    sectionId,
    index
  ) {
    const dots = sectionElement.querySelectorAll(
      `[data-hotspot-dot="${sectionId}"]`
    );

    dots.forEach((dot) => {
      dot.classList.remove('active');
    });

    const activeDot = sectionElement.querySelector(
      `[data-hotspot-dot="${sectionId}"][data-index="${index}"]`
    );

    if (activeDot) {
      activeDot.classList.add('active');
    }
  }

  function initAll() {
    document
      .querySelectorAll('[data-hotspot-section]')
      .forEach((section) => {
        init(section);
      });
  }

  return {
    init,
    initAll,
  };
})();

/* Initial Load */
document.addEventListener('DOMContentLoaded', () => {
  window.HotspotSlider.initAll();
});

/* Shopify Theme Editor */
document.addEventListener(
  'shopify:section:load',
  (event) => {
    const section = document.querySelector(
      `#shopify-section-${event.detail.sectionId}`
    );

    window.HotspotSlider.init(section);
  }
);

// Main product zoom

 window.ProductZoom = (() => {
  function init(scope = document) {
    const galleries = scope.querySelectorAll(
      '[data-product-zoom]'
    );
    galleries.forEach((gallery) => {
      const zoomType = gallery.dataset.productZoom;
      if (zoomType === 'zoom') {
        gallery.querySelectorAll('.zoom').forEach((image) => {
          if (
            typeof window.jQuery !== 'undefined' &&
            typeof jQuery(image).zoom === 'function'
          ) {
            jQuery(image).zoom(8);
          }
        });
      }
      /* ===== Outer Zoom ===== */
      if (zoomType === 'outer') {
        gallery
          .querySelectorAll('.dt-zoom-trigger')
          .forEach((image) => {
            if (
              typeof window.jQuery !== 'undefined' &&
              typeof jQuery(image).ezPlus === 'function'
            ) {
              jQuery(image).ezPlus();
            }
          });
      }
      /* ===== Cloud/Lens Zoom ===== */
      if (zoomType === 'cloud') {
        gallery.querySelectorAll('.zoom_out').forEach((image) => {
          if (
            typeof window.jQuery !== 'undefined' &&
            typeof jQuery(image).ezPlus === 'function'
          ) {
            jQuery(image).ezPlus({
              zoomType: 'lens',
              lensShape: 'round',
              lensSize: 150,
              zoomLevel: 2,
            });
          }
        });
      }
    });
  }

  function bindEvents() {
    document.addEventListener('click', (event) => {
      const notifyBtn = event.target.closest('#notify-me');

      if (!notifyBtn) return;

      event.preventDefault();

      const wrapper = document.querySelector(
        '#notify-me-wrapper'
      );

      if (!wrapper) return;

      wrapper.classList.toggle('active');

      if (wrapper.classList.contains('active')) {
        wrapper.style.display = 'block';
      } else {
        wrapper.style.display = 'none';
      }
    });
  }

  return {
    init,
    bindEvents,
  };
})();

/* Initial Load */
document.addEventListener('DOMContentLoaded', () => {
  window.ProductZoom.init();
  window.ProductZoom.bindEvents();
});

/* Shopify Theme Editor */
document.addEventListener(
  'shopify:section:load',
  (event) => {
    const section = document.querySelector(
      `#shopify-section-${event.detail.sectionId}`
    );

    if (section) {
      window.ProductZoom.init(section);
    }
  }
);

// Newsletter pop

window.NewsletterPopup = (() => {
  function init(scope = document) {
    const container = scope.querySelector(
      '#newsletter-container'
    );

    if (!container) return;

    const delay =
      Number(container.dataset.delay) || 0;

    const expires =
      Number(container.dataset.expires) || 1;

    if (!getCookie('NewsletterCookie')) {
      setTimeout(() => {
        showPopup(container);
      }, delay);
    } else {
      container.style.display = 'none';
    }

    bindCloseEvents(container, expires);
    bindSuccessButton(container);
    bindFormSubmit(container, expires);
  }

  function bindCloseEvents(container, expires) {
    const closeElements = container.querySelectorAll(
      '.close-window, .newsletter-container-overlay'
    );

    closeElements.forEach((element) => {
      element.addEventListener('click', (event) => {
        event.preventDefault();

        hidePopup(container);

        setCookie(
          'NewsletterCookie',
          'cookie-has-been-set',
          expires
        );
      });
    });
  }

  function bindSuccessButton(container) {
    const successButton = container.querySelector(
      '.newsletter-success button'
    );

    if (!successButton) return;

    successButton.addEventListener('click', () => {
      window.location.replace(
        container.dataset.shopUrl
      );
    });
  }

  function bindFormSubmit(container, expires) {
    const forms =
      container.querySelectorAll('.contact-form');

    forms.forEach((form) => {
      form.addEventListener('submit', () => {
        setCookie(
          'NewsletterCookie',
          'cookie-has-been-set',
          expires
        );
      });
    });
  }

  function showPopup(container) {
    container.style.display = 'block';
    container.style.opacity = '1';
    container.style.visibility = 'visible';
    container.classList.add('show-modal');

    document.body.style.overflowY = 'hidden';
    document.body.style.height = '100vh';
  }

  function hidePopup(container) {
    container.style.opacity = '0';
    container.style.visibility = 'hidden';
    container.style.pointerEvents = 'none';
    container.classList.remove('show-modal');

    document.body.style.overflowY = 'auto';
    document.body.style.height = 'auto';
  }

  function setCookie(name, value, days) {
    const date = new Date();

    date.setTime(
      date.getTime() +
        days * 24 * 60 * 60 * 1000
    );

    const expires =
      'expires=' + date.toUTCString();

    document.cookie =
      `${name}=${value}; ${expires}; path=/`;
  }

  function getCookie(name) {
    const cookieName = name + '=';

    const cookies = document.cookie.split(';');

    for (let cookie of cookies) {
      cookie = cookie.trim();

      if (cookie.indexOf(cookieName) === 0) {
        return cookie.substring(
          cookieName.length,
          cookie.length
        );
      }
    }

    return '';
  }

  return {
    init,
  };
})();

/* Initial Load */
document.addEventListener('DOMContentLoaded', () => {
  window.NewsletterPopup.init();
});

/* Shopify Theme Editor */
document.addEventListener(
  'shopify:section:load',
  (event) => {
    const section = document.querySelector(
      `#shopify-section-${event.detail.sectionId}`
    );

    if (section) {
      window.NewsletterPopup.init(section);
    }
  }
);

//offer pop-up

window.OfferPopup = (() => {
  function init(scope = document) {
    const popup = scope.querySelector('#custom-popup');

    if (!popup) return;

    const modal = scope.querySelector('#openModal1.modalDialog1');
    const emailInput = scope.querySelector('#email');
    const errorMessage = scope.querySelector('.error-message');
    const modalContainer = scope.querySelector('.modal1');

    /* Cookie Check */
    if (getCookie('dT_offer-cookie') === 'closed') {
      popup.style.display = 'none';
    } else {
      popup.style.display = 'block';
    }

    /* Close Popup */
    scope
      .querySelectorAll('.popup-close, .close1, .dT_close')
      .forEach((button) => {
        button.addEventListener('click', () => {
          popup.style.display = 'none';

          if (modal) {
            modal.classList.remove('offer-model__opened');
          }

          setCookie('dT_offer-cookie', 'closed', 1);
        });
      });

    /* Open Modal */
    const popupContent = popup.querySelector('.popup-content');

    if (popupContent && modal) {
      popupContent.addEventListener('click', () => {
        modal.classList.add('offer-model__opened');
      });
    }

    /* Subscribe */
    scope.querySelectorAll('.subscribe-btn').forEach((button) => {
      button.addEventListener('click', () => {
        if (errorMessage) {
          errorMessage.textContent = '';
        }

        const email = emailInput?.value || '';

        if (validateEmail(email)) {
          if (!modalContainer.querySelector('.thank-you')) {
            modalContainer.insertAdjacentHTML(
              'beforeend',
              `
                <div class="thank-you">
                  <i class="fa fa-check"></i>
                  Thank you for subscribing!
                </div>
              `
            );
          }
        } else {
          if (errorMessage) {
            errorMessage.textContent =
              'Invalid email address. Please enter a valid email.';
          }
        }
      });
    });
  }

  function validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function setCookie(name, value, days) {
    const date = new Date();

    date.setTime(
      date.getTime() + days * 24 * 60 * 60 * 1000
    );

    document.cookie =
      `${name}=${value}; expires=${date.toUTCString()}; path=/`;
  }

  function getCookie(name) {
    const cookieName = `${name}=`;

    const cookies = document.cookie.split(';');

    for (let cookie of cookies) {
      cookie = cookie.trim();

      if (cookie.indexOf(cookieName) === 0) {
        return cookie.substring(cookieName.length);
      }
    }

    return '';
  }

  return {
    init,
  };
})();

/* Initial Load */
document.addEventListener('DOMContentLoaded', () => {
  window.OfferPopup.init();
});

/* Shopify Theme Editor */
document.addEventListener('shopify:section:load', (event) => {
  const section = document.querySelector(
    `#shopify-section-${event.detail.sectionId}`
  );

  if (section) {
    window.OfferPopup.init(section);
  }
});

// Discount code

window.CartDiscount = (() => {
  function init(scope = document) {
    const applyBtn = scope.querySelector(
      '#apply-discount-btn'
    );

    const discountCodeError = scope.querySelector(
      '#discount-code-error'
    );

    const discountCodeInput = scope.querySelector(
      '#discount-code-input'
    );

    if (!applyBtn || !discountCodeInput) return;

    applyBtn.addEventListener('click', async (event) => {
      event.preventDefault();

      await applyDiscount(
        discountCodeInput,
        discountCodeError
      );
    });
  }

  async function applyDiscount(
    input,
    errorElement
  ) {
    const discountCode = input.value.trim();

    if (!discountCode) return;

    try {
      const checkResponse = await fetch(
        `/discount/${encodeURIComponent(discountCode)}`
      );

      if (!checkResponse.ok) {
        throw new Error('Invalid code');
      }

      await fetch('/cart/update.js', {
        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
        },

        body: JSON.stringify({
          discounts: discountCode,
        }),
      });

      await refreshCartUI();

      showMessage(
        errorElement,
        'Discount applied!',
        false
      );

      window.location.href = '/cart';
    } catch (error) {
      showMessage(
        errorElement,
        `Error: ${error.message}`,
        true
      );
    }
  }

  async function refreshCartUI() {
    const cart = await fetch('/cart.js').then((res) =>
      res.json()
    );

    const cartCount =
      document.querySelector('.cart-count');

    if (cartCount) {
      cartCount.textContent = cart.item_count;
    }

    const subtotalEl = document.querySelector(
      '.cart__subtotal .money'
    );

    if (subtotalEl) {
      subtotalEl.textContent =
        Shopify.formatMoney(cart.total_price);
    }
  }

  function showMessage(
    element,
    text,
    isError = false
  ) {
    if (!element) return;

    element.textContent = text;

    element.style.color = isError
      ? '#ff0000'
      : '#008000';

    element.style.display = 'block';

    setTimeout(() => {
      element.style.display = 'none';
    }, 5000);
  }

  return {
    init,
  };
})();

/* Initial Load */
document.addEventListener('DOMContentLoaded', () => {
  window.CartDiscount.init();
});

/* Shopify Theme Editor */
document.addEventListener(
  'shopify:section:load',
  (event) => {
    const section = document.querySelector(
      `#shopify-section-${event.detail.sectionId}`
    );

    if (section) {
      window.CartDiscount.init(section);
    }
  }
);

// Enquery modal

window.EnquiryModal = (() => {
  function init(scope = document) {
    const modal = scope.querySelector('.enquiry-modal');

    const trigger = scope.querySelector(
      '#trigger-enquiry'
    );

    const closeBtn = scope.querySelector(
      '.enquiry-modal .close-button'
    );

    if (!modal || !trigger || !closeBtn) return;

    function toggleModal() {
      modal.classList.toggle('show-enquiry');

      document.body.classList.toggle(
        'enquiry-overlay'
      );
    }

    trigger.addEventListener('click', () => {
      toggleModal();
    });

    closeBtn.addEventListener('click', () => {
      toggleModal();
    });

    window.addEventListener('click', (event) => {
      if (event.target === modal) {
        toggleModal();
      }
    });
  }

  return {
    init,
  };
})();

/* Initial Load */
document.addEventListener('DOMContentLoaded', () => {
  window.EnquiryModal.init();
});

/* Shopify Theme Editor */
document.addEventListener(
  'shopify:section:load',
  (event) => {
    const section = document.querySelector(
      `#shopify-section-${event.detail.sectionId}`
    );

    if (section) {
      window.EnquiryModal.init(section);
    }
  }
);

// fake visitors

 window.FakeCounter = (() => {
    function init(scope = document) {
      const counters = scope.querySelectorAll(
        '[data-fake-counter]'
      );

      counters.forEach((counterWrapper) => {
        const counter = counterWrapper.querySelector(
          '[data-dynamic-counter]'
        );

        if (!counter) return;

        let min = Number(counterWrapper.dataset.min) || 1;
        let max = Number(counterWrapper.dataset.max) || 100;

        let current =
          Math.floor(
            Math.random() * (max - min + 1)
          ) + min;

        const fluctuations = [
          1,
          2,
          3,
          4,
          5,
          10,
          -1,
          -2,
          -3,
          -4,
          -5,
        ];

        const boosts = [10, 20, 15];

        counter.textContent = current;

        setInterval(() => {
          const randomChange =
            fluctuations[
              Math.floor(
                Math.random() *
                  fluctuations.length
              )
            ];

          current += randomChange;

          if (current <= 10) {
            current +=
              boosts[
                Math.floor(
                  Math.random() * boosts.length
                )
              ];
          }

          if (current > 200) {
            current -=
              boosts[
                Math.floor(
                  Math.random() * boosts.length
                )
              ];
          }

          counter.textContent = current;
        }, 1000);
      });
    }

    return {
      init,
    };
  })();

  /* Initial Load */
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      window.FakeCounter.init();
    }
  );

  /* Shopify Theme Editor */
  document.addEventListener(
    'shopify:section:load',
    (event) => {
      const section = document.querySelector(
        `#shopify-section-${event.detail.sectionId}`
      );

      if (section) {
        window.FakeCounter.init(section);
      }
    }
  );

// Gift wrapping

 window.GiftWrap = (() => {
  function init(scope = document) {
    const giftWrap = scope.querySelector(
      '[data-gift-wrap]'
    );

    if (!giftWrap) return;

    const variantId = Number(
      giftWrap.dataset.giftWrapVariant
    );

    const checkbox = scope.querySelector(
      '[name="attributes[gift-wrapping]"]'
    );

    if (!variantId || !checkbox) return;

    checkbox.addEventListener('change', () => {
      if (checkbox.checked) {
        setGiftWrap(variantId);
      } else {
        removeGiftWrap(variantId);
      }
    });

    handleInitialState(giftWrap, variantId);
  }

  async function setGiftWrap(variantId) {
    try {
      await fetch('/cart/update.js', {
        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
        },

        body: JSON.stringify({
          updates: {
            [variantId]: 1,
          },

          attributes: {
            'gift-wrapping': true,
          },
        }),
      });

      window.location.href = '/';
    } catch (error) {
      console.error(
        'Gift wrap add error:',
        error
      );
    }
  }

  async function removeGiftWrap(variantId) {
    try {
      await fetch('/cart/update.js', {
        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
        },

        body: JSON.stringify({
          updates: {
            [variantId]: 0,
          },

          attributes: {
            'gift-wrapping': '',
          },
        }),
      });

      window.location.href = '/';
    } catch (error) {
      console.error(
        'Gift wrap remove error:',
        error
      );
    }
  }

  function handleInitialState(
    giftWrap,
    variantId
  ) {
    const cartItems = Number(
      giftWrap.dataset.cartItems
    );

    const giftWrapsInCart = Number(
      giftWrap.dataset.giftWraps
    );

    const hasGiftAttribute =
      giftWrap.dataset.giftAttribute === 'true';

    /* Only gift wrap in cart */
    if (
      cartItems === 1 &&
      giftWrapsInCart > 0
    ) {
      removeGiftWrap(variantId);
    }

    /* Multiple gift wrap items */
    else if (giftWrapsInCart > 1) {
      setGiftWrap(variantId);
    }

    /* Missing cart attribute */
    else if (
      giftWrapsInCart > 0 &&
      !hasGiftAttribute
    ) {
      setGiftWrap(variantId);
    }

    /* Attribute exists but no item */
    else if (
      giftWrapsInCart === 0 &&
      hasGiftAttribute
    ) {
      removeGiftWrap(variantId);
    }
  }

  return {
    init,
  };
})();

/* Initial Load */
document.addEventListener('DOMContentLoaded', () => {
  window.GiftWrap.init();
});

/* Shopify Theme Editor */
document.addEventListener(
  'shopify:section:load',
  (event) => {
    const section = document.querySelector(
      `#shopify-section-${event.detail.sectionId}`
    );

    if (section) {
      window.GiftWrap.init(section);
    }
  }
);

// Sticky cart

document.addEventListener('click', (event) => {
  const closeBtn = event.target.closest(
    '.sticky-bar-close'
  );

  if (!closeBtn) return;

  const stickyForm = document.querySelector(
    '#sticky-bar-form'
  );

  if (!stickyForm) return;

  stickyForm.classList.add('visibility-hidden');
});

// gift card

window.GiftCard = (() => {
  function init(scope = document) {
    const qrElement = scope.querySelector(
      '.gift-card__qr-code'
    );

    if (
      qrElement &&
      typeof QRCode !== 'undefined'
    ) {
      new QRCode(qrElement, {
        text: qrElement.dataset.identifier,
        width: 120,
        height: 120,
        imageAltText:
          window.theme?.strings?.qrImageAlt || '',
      });
    }

    const copyButton = scope.querySelector(
      '.gift-card__copy-link'
    );

    const giftCardNumber = scope.querySelector(
      '.gift-card__number'
    );

    const successWrapper = scope.querySelector(
      '.gift-card__copy-success'
    );

    const template =
      scope.querySelector('template');

    if (
      !copyButton ||
      !giftCardNumber ||
      !successWrapper ||
      !template
    ) {
      return;
    }

    let isMessageDisplayed = false;

    copyButton.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(
          giftCardNumber.value
        );

        if (!isMessageDisplayed) {
          successWrapper.appendChild(
            template.content.cloneNode(true)
          );

          isMessageDisplayed = true;
        }
      } catch (error) {
        console.error(
          'Clipboard copy failed:',
          error
        );
      }
    });
  }

  return {
    init,
  };
})();

document.addEventListener(
  'DOMContentLoaded',
  () => {
    window.GiftCard.init();
  }
);

document.addEventListener('DOMContentLoaded', function () {
  const target = document.querySelector('.footer-logo');
  if (!target) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          target.classList.add('active');
        } else {
          target.classList.remove('active');
        }
      });
    },
    {
      threshold: 0.1
    }
  );

  observer.observe(target);
});

document.addEventListener('DOMContentLoaded', function() {
    const countryButton = document.querySelector('#HeaderCountryForm .dropdown-toggle');
    const countryWrapper = document.querySelector('#HeaderCountryForm .disclosure__list-wrapper');
    
    if (countryButton && countryWrapper) {
        countryButton.addEventListener('click', function() {
            countryWrapper.removeAttribute('hidden');
        });
    }
});